
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as appt714oqXFI3THznJHimC3CmJNVFOGgDUfURgwFH6meeEMeta } from "/opt/buildhome/repo/pages/app.vue?macro=true";
import { default as lca75c8E6pFJX4uiHJsvdx31Ilt8LF2GSW0XMsCFDQb9MkMeta } from "/opt/buildhome/repo/pages/lca.vue?macro=true";
import { default as about6Vgf2e_45ZWwa_45DDxcsm2LFgKBFkBxwt_su_XdCkSeybIMeta } from "/opt/buildhome/repo/pages/about.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as termsM_RN9_459iuNVtH23UOLrjvoINYU4b2nnq0grhd_RmiYYMeta } from "/opt/buildhome/repo/pages/terms.vue?macro=true";
import { default as contactxgbCBTXU_45d0XJYTpbmfD1UGZKjSEtzA80xt962KkT7QMeta } from "/opt/buildhome/repo/pages/contact.vue?macro=true";
import { default as cookieshtP6F02lBALtGxPTRKVnvGvawtAS2_45RpkQD0HOTY6WIMeta } from "/opt/buildhome/repo/pages/cookies.vue?macro=true";
import { default as join_45usxfzLN8Kr3K4jp_EbYWI3_455tFGOBVWL9mPKU_zfqWyMwMeta } from "/opt/buildhome/repo/pages/join-us.vue?macro=true";
import { default as privacyArxgULVZ2Zifu3wQfKQ0WvqaXaBxDlpI2F7eal9OET8Meta } from "/opt/buildhome/repo/pages/privacy.vue?macro=true";
import { default as docsEKVsNapdpIlFGo3bfL4dYZ_mE3e_fauyU9DHvkGHV8EMeta } from "/opt/buildhome/repo/pages/api/docs.vue?macro=true";
import { default as indexBJHg7gkO1jhYj3IyKaab9FGcusARBJzD_45gRgOSx4wmQMeta } from "/opt/buildhome/repo/pages/api/index.vue?macro=true";
import { default as forecaststgunpIcSaZpZ4TfLMX5PMTlV1KctEgn6dgS_450IQgx5MMeta } from "/opt/buildhome/repo/pages/forecasts.vue?macro=true";
import { default as indexV1Vws_UfiOV_7sHFbNbhAoB31BXf8h7WyoPlqeXIC64Meta } from "/opt/buildhome/repo/pages/anode/index.vue?macro=true";
import { default as consultancy5MZ4JKieEA4VK9ko5aDct9mrD0kfs3zDbgt_wao_45RkAMeta } from "/opt/buildhome/repo/pages/consultancy.vue?macro=true";
import { default as pastjTbKywpKi8BA0VR_fbnTpgIBxyAqP8Zt3gOyqrdVQWwMeta } from "/opt/buildhome/repo/pages/events/past.vue?macro=true";
import { default as newslettersFNlAXRz2yKH0Wa19Uz6NAhVDrLXYpWK_45SgjToeNwo3cMeta } from "/opt/buildhome/repo/pages/newsletters.vue?macro=true";
import { default as chartr3rn9Yk43VA8DzQ_z_T3HnuWuphPADYLyfp5oSyh05MMeta } from "/opt/buildhome/repo/pages/anode/prices/chart.vue?macro=true";
import { default as index26PnRex5Ak_45suLiH_k1HIoTKaRdogouS8VDlq8H6_twMeta } from "/opt/buildhome/repo/pages/anode/prices/index.vue?macro=true";
import { default as _91slug_93mKuO3HkhKWZn6x6Q8Gu6BUJs2NtedYnBD1gszUDIXYwMeta } from "/opt/buildhome/repo/pages/anode/prices/[slug].vue?macro=true";
import { default as pricesDSzs09F6ZLCQG29ymFDVPdlUYwfZF2Nb_45vKSwmRRZIgMeta } from "/opt/buildhome/repo/pages/anode/prices.vue?macro=true";
import { default as indexrKE5y1yBe1MpZTdEG_BdH_45IQpYwRVi8dC_45Ng_vJIENgMeta } from "/opt/buildhome/repo/pages/cobalt/index.vue?macro=true";
import { default as indexgV5H6VL612U6jL27JLgYyHNXmWydn7yq_TtYYRMF9bEMeta } from "/opt/buildhome/repo/pages/copper/index.vue?macro=true";
import { default as indexU0mRl8BtPWRyVs9v9mXNnL0sIofcrekH7VHBkj_OTTUMeta } from "/opt/buildhome/repo/pages/events/index.vue?macro=true";
import { default as excel_45add_45in66Lbw919jk_cewLyyoBoDlFfe0QIB_27_CP3fcl8Iw0Meta } from "/opt/buildhome/repo/pages/excel-add-in.vue?macro=true";
import { default as indexEi_45Uknbeg1CgFFca_45L5Ydki7XdS_u5UGtocjRA2uofIMeta } from "/opt/buildhome/repo/pages/nickel/index.vue?macro=true";
import { default as set_45passwordRVNlywD2VBOO_UxDrrgnf3Wgy4cZX6iXOZt5eJxN68sMeta } from "/opt/buildhome/repo/pages/set-password.vue?macro=true";
import { default as indexsSHEynImpmVJQBsgEWtpFbTIimvAlNbjHy0W37sieOIMeta } from "/opt/buildhome/repo/pages/account/index.vue?macro=true";
import { default as indexD2PZM2i5TGsluOtSKKcrPDVQJiZyp5yh9fbCRp_pA1AMeta } from "/opt/buildhome/repo/pages/cathode/index.vue?macro=true";
import { default as _91slug_93RvZMtPicDU0KWxDbagCqrRfxiNVvErblUw6QGTfQQkQMeta } from "/opt/buildhome/repo/pages/cobalt/[slug].vue?macro=true";
import { default as chartSoJMXbTvAjQCxJpXZgcYUAFZOzPeLumyP7Fde72GTMUMeta } from "/opt/buildhome/repo/pages/cobalt/prices/chart.vue?macro=true";
import { default as index1zfBnW0cRNv2eN29gwDOZs687CfLKFF3hUqzmCTHh98Meta } from "/opt/buildhome/repo/pages/cobalt/prices/index.vue?macro=true";
import { default as _91slug_93SJ5YyTlImcrhEYlKVSHCPye9ceo9bFaiVea9rSDaXhUMeta } from "/opt/buildhome/repo/pages/cobalt/prices/[slug].vue?macro=true";
import { default as price_45customisation_45tooltced3pSYcJYm7TG_45053B0Rd3de1hsJbyT4bXCsigDaQMeta } from "/opt/buildhome/repo/pages/cobalt/prices/price-customisation-tool.vue?macro=true";
import { default as prices2RRxBXMGU9iWoiPD1IuYW2q9wdb2oe_GC4W6ZkGqDaUMeta } from "/opt/buildhome/repo/pages/cobalt/prices.vue?macro=true";
import { default as copper_45weekly2SThJDX67dtLBHGWMX71Nqee9xbcsHXeIpbN4cNNnjsMeta } from "/opt/buildhome/repo/pages/copper-weekly.vue?macro=true";
import { default as portalQkWIVq9Q4LTJk7nfExKm1JsGTo6pTCcDLoEZyunm3mEMeta } from "/opt/buildhome/repo/pages/copper/portal.vue?macro=true";
import { default as _91slug_93iBWtnnrkRuyTsyx2RmfgEUrnQhbG8tPVQVaeOSmBPMcMeta } from "/opt/buildhome/repo/pages/events/[slug].vue?macro=true";
import { default as indexa8TZF5gFe8ppoZ05hiQiyaVGnNlztxvIaHmUgRiahtIMeta } from "/opt/buildhome/repo/pages/lithium/index.vue?macro=true";
import { default as _91slug_93ioCyLgO797rT4VKTQgM_YXDlBaSdSP7fSBqEOIPXLxIMeta } from "/opt/buildhome/repo/pages/nickel/[slug].vue?macro=true";
import { default as chart2HN2eqxHhuHGKdqUtY7zzNFP3lIT_9JAvisFTbkvnp0Meta } from "/opt/buildhome/repo/pages/nickel/prices/chart.vue?macro=true";
import { default as indexyl_45OzeNbqkwSta3hmXexzhQfmWKBjAQ_ymbIP1CuxzwMeta } from "/opt/buildhome/repo/pages/nickel/prices/index.vue?macro=true";
import { default as _91slug_93fk0slPu7RgEO8MO1aawZkiUeCtGOU8li47DkB8qUKgUMeta } from "/opt/buildhome/repo/pages/nickel/prices/[slug].vue?macro=true";
import { default as price_45customisation_45tool2CPFVSdlSq5gxrCi41fTk8IZrLTX5xVayu8KvFumXt0Meta } from "/opt/buildhome/repo/pages/nickel/prices/price-customisation-tool.vue?macro=true";
import { default as pricesGLmo5Hyj3LNYlaN4s8_45JlstKyn3k29jrlBcYww8ntVcMeta } from "/opt/buildhome/repo/pages/nickel/prices.vue?macro=true";
import { default as chartg8b0cCAjfokZMR0k7H5g41bJ3mPHMfG3xqHj1I312BsMeta } from "/opt/buildhome/repo/pages/cathode/prices/chart.vue?macro=true";
import { default as indexnvKBJb1g0UuHHc1HMLtXSpMGhp2uHP85xJo5KtEAAVYMeta } from "/opt/buildhome/repo/pages/cathode/prices/index.vue?macro=true";
import { default as _91slug_93gFnDl6WQqejdL_IDw3NOYyQGINkXV2IYYUzNpo4uJE4Meta } from "/opt/buildhome/repo/pages/cathode/prices/[slug].vue?macro=true";
import { default as pricesfuwmmz7gcD24VAxvHEUL_45wZuOtwCkWu3ZygmjyvQGHwMeta } from "/opt/buildhome/repo/pages/cathode/prices.vue?macro=true";
import { default as summitsl52L_45hp7I_45_TCKNs0NFQtB5HLSOZ7AXzfsE_ZabosmsMeta } from "/opt/buildhome/repo/pages/events/summits.vue?macro=true";
import { default as lithium_45pricesytpkbQHbYuW_45iLVc2_lFLPW5zveuYVFC_Z5pxrHCda8Meta } from "/opt/buildhome/repo/pages/lithium-prices.vue?macro=true";
import { default as _91slug_93QiR_45IFfz5gnb_PURgiRlEBQJJbD9_45p7E65H1M_45cokikMeta } from "/opt/buildhome/repo/pages/lithium/[slug].vue?macro=true";
import { default as charteL_ZgnPhxhgSBK4GsjTlFu_ehPBPpDJwg1K8_454R41sEMeta } from "/opt/buildhome/repo/pages/lithium/prices/chart.vue?macro=true";
import { default as index5RgLDA_w9cQRH1inImhoGpSVl2CsHinA3oF4agwFdMsMeta } from "/opt/buildhome/repo/pages/lithium/prices/index.vue?macro=true";
import { default as _91slug_9376Ef1pqhSPK3MZz2fN_45203gkNSSiose3PP63yAmbnoEMeta } from "/opt/buildhome/repo/pages/lithium/prices/[slug].vue?macro=true";
import { default as price_45customisation_45tooliq2dWHKcC7_XbP6xYy00RJIlmy31IOKaZd7PpdUisUEMeta } from "/opt/buildhome/repo/pages/lithium/prices/price-customisation-tool.vue?macro=true";
import { default as pricesr04WsZVosMYNPTGibZ9vrj0RPEfb74rVl8gFiKVWz9MMeta } from "/opt/buildhome/repo/pages/lithium/prices.vue?macro=true";
import { default as reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta } from "/opt/buildhome/repo/pages/reset-password.vue?macro=true";
import { default as sustainability_452inpZEfBkqcylTucQFeGv6X_r5_458dtUHpKmzvnZrUQMeta } from "/opt/buildhome/repo/pages/sustainability.vue?macro=true";
import { default as webinarsmdW5CUPTHXNSWXYTk1SoBN5F57_45wmmLe8kOeNFxqrn8Meta } from "/opt/buildhome/repo/pages/events/webinars.vue?macro=true";
import { default as index7ldmIiBtJcKUbnfUx1KhOMc7CkkdFfkXrATN7i4bpkEMeta } from "/opt/buildhome/repo/pages/fluorspar/index.vue?macro=true";
import { default as indexfTjnSj5ZaZDm6sPT15BVMjUZ_jS6KmFryaTAN9d_45F4oMeta } from "/opt/buildhome/repo/pages/manganese/index.vue?macro=true";
import { default as indexX_45km_45nzcK8KTn2OSWLYqrEQrtgWpHsGfisnHF3fteV0Meta } from "/opt/buildhome/repo/pages/phosphate/index.vue?macro=true";
import { default as indexiHP_459aTnVcuNachfyBCN79XBQffLB7okl91Zmpui_45EkMeta } from "/opt/buildhome/repo/pages/recycling/index.vue?macro=true";
import { default as stellantisNgPs5Ajd0v9U8xBNgSenw0FZO5BjCvrliVQp8ZFYuPYMeta } from "/opt/buildhome/repo/pages/forms/stellantis.vue?macro=true";
import { default as industry_45reportsiR_45nxkyyiPQRLDvRf_45NUScCQpRjtMKqeAIwBBpdHCp4Meta } from "/opt/buildhome/repo/pages/industry-reports.vue?macro=true";
import { default as _91slug_93vMVVn_2AU_LYP65s8waJQX5QVA8LPJAkVtjeJEIdXYMMeta } from "/opt/buildhome/repo/pages/recycling/[slug].vue?macro=true";
import { default as portalkwOl_lOUEv830UjhBpD7MvDLyfTP_l_Mrpx4ua521xYMeta } from "/opt/buildhome/repo/pages/recycling/portal.vue?macro=true";
import { default as _91slug_93JEovECEqg4zZNE7gGOLUW0QIgtyboHU4wjAEf82wtJMMeta } from "/opt/buildhome/repo/pages/membership/[slug].vue?macro=true";
import { default as newsletter_45signupGLF6F7j4pMpOwbrs6zbopX7McgrcbKDXfmBW8p6DKdAMeta } from "/opt/buildhome/repo/pages/newsletter-signup.vue?macro=true";
import { default as policy_45newsletteriw_45Rc19jRk2qQOz7twALR0WVubqPA626sxDGKNooC20Meta } from "/opt/buildhome/repo/pages/policy-newsletter.vue?macro=true";
import { default as indexAXftbV7OCVl2z5M2zjEzZx8dInE_45rT3_BIygGoNXNEUMeta } from "/opt/buildhome/repo/pages/rare-earths/index.vue?macro=true";
import { default as api_45accessPwZoObqN_o4XW0cPBPJfLl3QkAXdTVdAB4daz7PSOfUMeta } from "/opt/buildhome/repo/pages/account/api-access.vue?macro=true";
import { default as forecasts3IvqGGprpUYGk5jhOVbHxacCEOarLvy77lvyeYrpZO4Meta } from "/opt/buildhome/repo/pages/anode/data-reports/forecasts.vue?macro=true";
import { default as price_45assessmentsPWvhULnhXknsD4_45gy15GT4vXVs2V6i6NiotM3It0JGUMeta } from "/opt/buildhome/repo/pages/anode/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportsBY_xoXIpCtAQVdXM56XZdxB8pUJYgrDgTKJiYX6GZ6EMeta } from "/opt/buildhome/repo/pages/anode/data-reports.vue?macro=true";
import { default as market_45assessmentsm60EINFruAvWvHY5EGL8s4ccZgnAwUL8fnXGLEcMlScMeta } from "/opt/buildhome/repo/pages/market-assessments.vue?macro=true";
import { default as _91slug_93nLwwDfZ_FuTf7ShngM6xEfFsHlixpW07o_k_45qAarL2IMeta } from "/opt/buildhome/repo/pages/rare-earths/[slug].vue?macro=true";
import { default as charttexBeRB82x0IvBMp1IzjNFVcyXJWtjwtJohWEHNyyVIMeta } from "/opt/buildhome/repo/pages/rare-earths/prices/chart.vue?macro=true";
import { default as indexT4WR7U87NgilL3KdNawsWbjnA4yosLts5oSjEK2ON3IMeta } from "/opt/buildhome/repo/pages/rare-earths/prices/index.vue?macro=true";
import { default as _91slug_93ZXw6TB6Fu9btkVLSm4zMahCcv_3wP2SDvoYoSetLlqUMeta } from "/opt/buildhome/repo/pages/rare-earths/prices/[slug].vue?macro=true";
import { default as pricesVhUiI68Gm9juvXqkg8W919ZjqghBWqxKglQ8B2FAU6oMeta } from "/opt/buildhome/repo/pages/rare-earths/prices.vue?macro=true";
import { default as indexcQ5OztjZAR_n7tWGadAOh373Ci3LNKfJ1l2YSjfEGesMeta } from "/opt/buildhome/repo/pages/announcements/index.vue?macro=true";
import { default as forecastswWTMCeEeZMqD7_45ROr4fhdkb2hpM8LYCpqhPhrQ6efAwMeta } from "/opt/buildhome/repo/pages/cobalt/data-reports/forecasts.vue?macro=true";
import { default as sustainabilityxgZJggI7Gsr_oldEtDvR9F9CVAth6iGjmMozyiJEfEIMeta } from "/opt/buildhome/repo/pages/cobalt/data-reports/sustainability.vue?macro=true";
import { default as price_45assessmentsMafhNoNLzAIaTTdXEpBpSpk38u_45NP39Z9R8TMUL_45W6sMeta } from "/opt/buildhome/repo/pages/cobalt/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportss4K40O4facPwT8J6I6KcKLXbTSpCKg9KqfxrI_45RLvAYMeta } from "/opt/buildhome/repo/pages/cobalt/data-reports.vue?macro=true";
import { default as forecastsY2ZE2pWQVzJGhKhpCvNTuUnAxynX9paY6STXUCZKXH8Meta } from "/opt/buildhome/repo/pages/copper/data-reports/forecasts.vue?macro=true";
import { default as copper_45briefingo_BfcMqB92NCOddwCLy0UzA4WXHyApkNb0DUhdZbTSEMeta } from "/opt/buildhome/repo/pages/copper/data-reports/copper-briefing.vue?macro=true";
import { default as data_45reportsZtrftu_45s1VwG6KE3T_45EdhmaZSLngbHCK_45NRvPSdDxowMeta } from "/opt/buildhome/repo/pages/copper/data-reports.vue?macro=true";
import { default as _91slug_93Bta4QSrRN_45nDe2QgSQrWd472YO5jF7_X5CkfKQ_thkAMeta } from "/opt/buildhome/repo/pages/downloadform/[slug].vue?macro=true";
import { default as index__45TK_TnvF9qhKFqpbKdBmQB_45xlyP2OO7PRP5oEfUW5sMeta } from "/opt/buildhome/repo/pages/methodologies/index.vue?macro=true";
import { default as forecastsZHqrEclrJvzMk9Pp8EB4mZIAUWmJFgkY_4553JzhajdHoMeta } from "/opt/buildhome/repo/pages/nickel/data-reports/forecasts.vue?macro=true";
import { default as sustainabilityU2Q02RBzAGTm2TPdC1CSUIdoeVl10Y7r5LBJMbi4tUQMeta } from "/opt/buildhome/repo/pages/nickel/data-reports/sustainability.vue?macro=true";
import { default as price_45assessmentsl2WZJLg1kRluP_LgLDdeppiF7cuYQGYEEAeAU76UKvYMeta } from "/opt/buildhome/repo/pages/nickel/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportsdkxV049C969_ZLDTteN4O4gjbrDIelK2_454p5rjogmucMeta } from "/opt/buildhome/repo/pages/nickel/data-reports.vue?macro=true";
import { default as indexwZyhkeIhahNSKbj9Mv2sC2smueJzC_OcAcagsfvyxq0Meta } from "/opt/buildhome/repo/pages/silicon-anode/index.vue?macro=true";
import { default as _91slug_93yDEcX0W_45HO_45P_A_w5Dl4yAM1_YIQFnAta22L2EeyjEsMeta } from "/opt/buildhome/repo/pages/announcements/[slug].vue?macro=true";
import { default as forecastsy7ILvQmepxTh90vSjydKOfDz12wakD5W24y54oSkI7oMeta } from "/opt/buildhome/repo/pages/cathode/data-reports/forecasts.vue?macro=true";
import { default as price_45assessmentszPSDrMkqlF6_45PDwG6_CA1A0GCeTJiEB1fzPyAu_45M4BUMeta } from "/opt/buildhome/repo/pages/cathode/data-reports/price-assessments.vue?macro=true";
import { default as market_45assessmentsNBA70qiYi6i8b8xgJq7ija5smxnaEpflZAwTGrIjPRUMeta } from "/opt/buildhome/repo/pages/cathode/data-reports/market-assessments.vue?macro=true";
import { default as data_45reports06kz19v3kt4p0B2H0NMCfEWqOXyyUjRpK3Le1hz7WcgMeta } from "/opt/buildhome/repo/pages/cathode/data-reports.vue?macro=true";
import { default as forecasts81PBPUNkXuwxgNjH6STLKAH4VxrROISq69bG5a994VgMeta } from "/opt/buildhome/repo/pages/lithium/data-reports/forecasts.vue?macro=true";
import { default as sustainability_45Cvpto0q1X29YdY8LdDbL1f4tL5C3xTcpmKUaQA83JgMeta } from "/opt/buildhome/repo/pages/lithium/data-reports/sustainability.vue?macro=true";
import { default as price_45assessmentsoQ_tH3hE3ijN35zbk_45BsN1EBajFvDlcZE2adkwPYF4IMeta } from "/opt/buildhome/repo/pages/lithium/data-reports/price-assessments.vue?macro=true";
import { default as data_45reports1c56zMU_Ga1PJyuYOu2dBK12xqN2JkpGcdgi_tQFadIMeta } from "/opt/buildhome/repo/pages/lithium/data-reports.vue?macro=true";
import { default as indexUVUbiAmmZwjFLCnBTStGBUj8_45nU2H71POr7C2uvRudkMeta } from "/opt/buildhome/repo/pages/new-technology/index.vue?macro=true";
import { default as subscriptionsef8m95Q1E_45J79LcAd_45RAY3qfixo1CSpfsxjqNkfKKfoMeta } from "/opt/buildhome/repo/pages/account/subscriptions.vue?macro=true";
import { default as videosy5MiVRdy2L0bmp2J41MlNQYSqsC55587_MPpizBiApIMeta } from "/opt/buildhome/repo/pages/anode/market-insights/videos.vue?macro=true";
import { default as analysis5FFClH0s3_Z9DfXtMj8JRr31rrY7vEU9mjOB__451cFxYMeta } from "/opt/buildhome/repo/pages/anode/market-insights/analysis.vue?macro=true";
import { default as critical_45insights_45JCgfsA4mqrMoEqIBpCOy8kJMR4hjCEFtfuOpNklEU4Meta } from "/opt/buildhome/repo/pages/anode/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsGuVDAInSEoIbTR5CcZq7vjv9mzDuccwlXoGaq_Zui1sMeta } from "/opt/buildhome/repo/pages/anode/market-insights.vue?macro=true";
import { default as lcayx_45ZHm5ATA3otzyD52GFUv_45YZrmQ_45PQTHcfQnZ9ibzYMeta } from "/opt/buildhome/repo/pages/cobalt/sustainability/lca.vue?macro=true";
import { default as overviewOiSHrrphhatmJCe2BWFVh1eCsjJUdfuG1J4L9LPEEEcMeta } from "/opt/buildhome/repo/pages/cobalt/sustainability/overview.vue?macro=true";
import { default as sustainability_45indexPxo5pxfv8uRaz2YnuUWwtFYrOWSXhrQLbd4KQNp__45hMMeta } from "/opt/buildhome/repo/pages/cobalt/sustainability/sustainability-index.vue?macro=true";
import { default as battery_45emissions_45analyserRVHcEDRELKMgIfh2VLBrLyA0e5hfosredJ9mT6QhHdYMeta } from "/opt/buildhome/repo/pages/cobalt/sustainability/battery-emissions-analyser.vue?macro=true";
import { default as sustainabilityB3Bm5CXSr7bLQzy_mp_45BITKB7N_455RU8OE43qP9HaFD4Meta } from "/opt/buildhome/repo/pages/cobalt/sustainability.vue?macro=true";
import { default as benchmark_45weekFW2BvZPDzRLpZJV_45zZDrj91vjRe8QwUlhrU81GsSZDYMeta } from "/opt/buildhome/repo/pages/events/benchmark-week.vue?macro=true";
import { default as mineral_45pricing_45chartBPwVoVy2WMC6H40ryz1dpRgmpUlzQZjSBOGocRC_FH8Meta } from "/opt/buildhome/repo/pages/mineral-pricing-chart.vue?macro=true";
import { default as portalgX1PHDCPzycm7l7BYZTgbFP18c9puZpB1OjTvTmPickMeta } from "/opt/buildhome/repo/pages/new-technology/portal.vue?macro=true";
import { default as lcaZaBFLidf51Nik5KU1lm_453FA7IkhtqtdO4W0IHi68eD0Meta } from "/opt/buildhome/repo/pages/nickel/sustainability/lca.vue?macro=true";
import { default as overviewpDONLyavM7wWQwmoi5fqHk34cz83iURPUSqdsrJbz2cMeta } from "/opt/buildhome/repo/pages/nickel/sustainability/overview.vue?macro=true";
import { default as sustainability_45indexWE8xj0imX3ZZJIUpQw9UjmmjU6SCaaj1ouM_wrizCHUMeta } from "/opt/buildhome/repo/pages/nickel/sustainability/sustainability-index.vue?macro=true";
import { default as battery_45emissions_45analysergno0cEzBubXN3m5PAmlCNtJkOVPBPE9xB6A9vmbWTsoMeta } from "/opt/buildhome/repo/pages/nickel/sustainability/battery-emissions-analyser.vue?macro=true";
import { default as sustainability2jCBcwzGLi7J36_rCystW_45uJn8AuXafDEREovIV5mKgMeta } from "/opt/buildhome/repo/pages/nickel/sustainability.vue?macro=true";
import { default as index39kesrz0VIuwodXEvkWwpVv124mp_X4fvrZB4BgNeGwMeta } from "/opt/buildhome/repo/pages/price-dashboard/index.vue?macro=true";
import { default as videosfjbFi30_45rY_jXx60zayApKwRibQjf53Rw1saKzWSQSEMeta } from "/opt/buildhome/repo/pages/cobalt/market-insights/videos.vue?macro=true";
import { default as analysisu1fmvvcBMbhS6vTsxbg8lghUNehgRZvqWQsKeeko6ggMeta } from "/opt/buildhome/repo/pages/cobalt/market-insights/analysis.vue?macro=true";
import { default as critical_45insightscjYrhSCoDX07vbvyFXAWp0FdMpxSjiQbUCdqKHemmtIMeta } from "/opt/buildhome/repo/pages/cobalt/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsbJEI_45ucptiXRxpSd_Cy_sB5T0VQa14vCGmL6kcyuGm4Meta } from "/opt/buildhome/repo/pages/cobalt/market-insights.vue?macro=true";
import { default as videosnrJQHrkuQe7hWYr9yVKTOR0RUrMZ9ivKalf9UrgTUQoMeta } from "/opt/buildhome/repo/pages/copper/market-insights/videos.vue?macro=true";
import { default as analysis5_SOI7W6_6pDje3YGNhXZegE7x8AmH3rqGgNta40wlYMeta } from "/opt/buildhome/repo/pages/copper/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsDVMy160VIkGeQGSlyRG1_vzpwiF3Kw1E2fFXW55ILxkMeta } from "/opt/buildhome/repo/pages/copper/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsw1SXVjd1K9YU9hqNXrBx8uQ4tHehmEHMMN8Ki8f8FugMeta } from "/opt/buildhome/repo/pages/copper/market-insights.vue?macro=true";
import { default as forecastsa9WT5jxj6deKOkW6Ezb_Fmy3CLfTRgcddOaSyw1KGB8Meta } from "/opt/buildhome/repo/pages/fluorspar/data-reports/forecasts.vue?macro=true";
import { default as data_45reportsgbaZOc4gjryF3Jb_45qC35u4ccSIdKxv_pOB_45X1lc3ujUMeta } from "/opt/buildhome/repo/pages/fluorspar/data-reports.vue?macro=true";
import { default as lcaf7X6UACeaKEWCjUXVHYczDwgw_451G1iES2RS_L8AlTVsMeta } from "/opt/buildhome/repo/pages/lithium/sustainability/lca.vue?macro=true";
import { default as overview8T1RWuRf6net1QW8iUWX0WnZ7iioLX_JNeLJJBx3rw0Meta } from "/opt/buildhome/repo/pages/lithium/sustainability/overview.vue?macro=true";
import { default as sustainability_45indexheyROYfwaI3xtQFWRDpPpheqpIkTAik_njvWEAqucM4Meta } from "/opt/buildhome/repo/pages/lithium/sustainability/sustainability-index.vue?macro=true";
import { default as battery_45emissions_45analyserxkEwC5fkTnREyQ_QvfOtD3UPc04aVK30Eoit5eL_45268Meta } from "/opt/buildhome/repo/pages/lithium/sustainability/battery-emissions-analyser.vue?macro=true";
import { default as sustainabilityRRq6jml3Evu7C9B7lW5dnBywTM1smWIxhO_67TqtIbEMeta } from "/opt/buildhome/repo/pages/lithium/sustainability.vue?macro=true";
import { default as forecastsqhz6DZ_5ahlGd42Xj5a0DyDJJi9gd6wRdXGGydNHTDwMeta } from "/opt/buildhome/repo/pages/manganese/data-reports/forecasts.vue?macro=true";
import { default as data_45reportstLPdngfcbBB791bXHQbpUAM6P1VbYJ_q4yzgxDCepnUMeta } from "/opt/buildhome/repo/pages/manganese/data-reports.vue?macro=true";
import { default as indexKM6uOX9_45GMWZMOKmdmrvqcgwfLORqhSrZwJ5gMM9qpkMeta } from "/opt/buildhome/repo/pages/natural-graphite/index.vue?macro=true";
import { default as videosct7YXBA8E9UNyUyx0giUwiUwnnmNEhFBFmxvm88K1r0Meta } from "/opt/buildhome/repo/pages/nickel/market-insights/videos.vue?macro=true";
import { default as analysisV8x2wsWnfOSi9VUF_UUkqogCWlPrUwagyiDeFJ_45Xe0AMeta } from "/opt/buildhome/repo/pages/nickel/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsyqJb75QXjoaS718x_45Tp_lDTrNhai_45P2bXbeAO_45MoIEIMeta } from "/opt/buildhome/repo/pages/nickel/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsW8daf7d1dbOMjPfxDsbYCDGpworFjvtBVU_gAhTKDbAMeta } from "/opt/buildhome/repo/pages/nickel/market-insights.vue?macro=true";
import { default as forecastsWJXcSRnSJh6FSPydQa6fFBKhs5h_45s72Z4sVqBrnVoPsMeta } from "/opt/buildhome/repo/pages/phosphate/data-reports/forecasts.vue?macro=true";
import { default as data_45reportsI54m0M32_45SK3h16wa7wjcPyKmaR7dq5lORcWPtgTFqgMeta } from "/opt/buildhome/repo/pages/phosphate/data-reports.vue?macro=true";
import { default as _91id_93XFqkO2v2gzUCjs1czdPR6g8ld8FNSanJH_45P_45cUsImNEMeta } from "/opt/buildhome/repo/pages/preview/_postType/[id].vue?macro=true";
import { default as price_45spotlight_45signupcOsgul9b6WSsUQzT4WVvQb9YpI0_45H7hVjf2_n2GBCEkMeta } from "/opt/buildhome/repo/pages/price-spotlight-signup.vue?macro=true";
import { default as forecastseYADkzkcfdqJo1n_45Crnq_45UbTp9YNpvwa6_X_45YGBsmlwMeta } from "/opt/buildhome/repo/pages/recycling/data-reports/forecasts.vue?macro=true";
import { default as price_45assessments0dk6nCKYyPX1PHUqi0iWeP9voI8rYzlxkIS7NhO4xUEMeta } from "/opt/buildhome/repo/pages/recycling/data-reports/price-assessments.vue?macro=true";
import { default as data_45reports8U0FRTokFK4DfOLIG_452PiazaTs0mWOoc9PRwB5zJ55UMeta } from "/opt/buildhome/repo/pages/recycling/data-reports.vue?macro=true";
import { default as index59bt1rmJZPF5B1AXzbCYXGUlccWvaORTCmQyf8uvAR4Meta } from "/opt/buildhome/repo/pages/anode/capacity-database/index.vue?macro=true";
import { default as sodium_45ion_45anode6HYcK_455cnUsCcufm5p9YCRAO6kUog4fizC__4GxCdRcMeta } from "/opt/buildhome/repo/pages/anode/capacity-database/sodium-ion-anode.vue?macro=true";
import { default as capacity_45databasee7l3ptyb4PBHK49UF0_45vwBoZZBEicrXXeJVw5tkExhkMeta } from "/opt/buildhome/repo/pages/anode/capacity-database.vue?macro=true";
import { default as videosVoLh_OnGnlWqnnBqN8JN9lfZZ_45Ea5I1XftJUqPWNuM0Meta } from "/opt/buildhome/repo/pages/cathode/market-insights/videos.vue?macro=true";
import { default as analysis79bxjcLYh5cEitnEPVYtiQ04193bkSlt9Gi6A6gsnqoMeta } from "/opt/buildhome/repo/pages/cathode/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsjeY_p42kgvoKDh1Tk5P9ii1RJ1ImiHUF3gX29kwDkg4Meta } from "/opt/buildhome/repo/pages/cathode/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsU5gHCz9ft_nIlfyFVrFhUfmyeBS8gSirt5ow82_6xJ4Meta } from "/opt/buildhome/repo/pages/cathode/market-insights.vue?macro=true";
import { default as indexzLEiDkOCZUWh2fNZOqIuTeI9k6l_45ER5VHoD50Mr__scMeta } from "/opt/buildhome/repo/pages/events/africa-day/index.vue?macro=true";
import { default as indexnZ0IGNVXyytnnZsqKbQ6fcFwFfG9sH52Wy_tZWdic34Meta } from "/opt/buildhome/repo/pages/events/evfest2021/index.vue?macro=true";
import { default as indexfGIX7aTOH35AqhVx7c5x9PIL0YY6UY9ygH_mORdDEdMMeta } from "/opt/buildhome/repo/pages/events/nickel-day/index.vue?macro=true";
import { default as videosF8JU2lzZwewvlRH4KBsuhk7dlXWcNbgArzcdVrpWwjIMeta } from "/opt/buildhome/repo/pages/lithium/market-insights/videos.vue?macro=true";
import { default as analysis1a_FKHv0M2pcWOhwC5lzbYZBY0eHP2qRpN814d84iBQMeta } from "/opt/buildhome/repo/pages/lithium/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsIW0hwN71Mi1H06SnPg8GOL6Cld7e_eLTRieBqe99Ao8Meta } from "/opt/buildhome/repo/pages/lithium/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsM5dXX__45RoyRTwmx_synaTlnFC9iJdRQ1OcjPuFTys8YMeta } from "/opt/buildhome/repo/pages/lithium/market-insights.vue?macro=true";
import { default as _91slug_93hFDYNoOn5JPJkLetDsmmV6hESng88HNmx58klRfVDc4Meta } from "/opt/buildhome/repo/pages/natural-graphite/[slug].vue?macro=true";
import { default as charttcUJKh0e_45IU6ZIrIhnGeIADKU8HYidR06on1tbbpLVAMeta } from "/opt/buildhome/repo/pages/natural-graphite/prices/chart.vue?macro=true";
import { default as indexyiHprQZOFqpNOOiyJeC3w2NXSv745ik1WVFMuHBu0CkMeta } from "/opt/buildhome/repo/pages/natural-graphite/prices/index.vue?macro=true";
import { default as _91slug_93I_U2Nt3gflNitMu9eI9Kql7pF5bKHQX42TevxWRWMUYMeta } from "/opt/buildhome/repo/pages/natural-graphite/prices/[slug].vue?macro=true";
import { default as price_45customisation_45toolKj1TXNon5EeyEnhM_45bQRH5TtD_2W9n6cwbF1EZQkOPEMeta } from "/opt/buildhome/repo/pages/natural-graphite/prices/price-customisation-tool.vue?macro=true";
import { default as pricesPqFK_45fp_5oTSpxAe8qj6c98yKd4HTrJ524ET1K5N6P4Meta } from "/opt/buildhome/repo/pages/natural-graphite/prices.vue?macro=true";
import { default as indexbFJbU_45uU80OU1a3ygzJMjogRXw4o_WfLztOXlXeLBJEMeta } from "/opt/buildhome/repo/pages/price-assessments/index.vue?macro=true";
import { default as indexsYsSJRK5UeiLHo5_450PqXBpukgBGGlOQ19NwmLGxmywkMeta } from "/opt/buildhome/repo/pages/events/ev-festival/index.vue?macro=true";
import { default as forecasts2F3r_45x7PZfr4UlpYbQvHJ33qnzThmxsW7CPDlBl5TyUMeta } from "/opt/buildhome/repo/pages/rare-earths/data-reports/forecasts.vue?macro=true";
import { default as sustainabilityDxjSzjD10HbEV9EidxDExoIe4wZrbT1WlLSNMNxpECoMeta } from "/opt/buildhome/repo/pages/rare-earths/data-reports/sustainability.vue?macro=true";
import { default as price_45assessmentsC3_45XGH3WzlJR_45ilbNxGyC5Qd0t3fd2scvM0JQF9XOv0Meta } from "/opt/buildhome/repo/pages/rare-earths/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportsNEZHWzcOS_gek61NkZAyrUjqaEW27iFykqQc6RnDILMMeta } from "/opt/buildhome/repo/pages/rare-earths/data-reports.vue?macro=true";
import { default as indexSrflw_45RKtNDaCfGXveUmgg8K5vQq_9oSJ4p2rbcBwfUMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/index.vue?macro=true";
import { default as indexg_VlOVtVubGPiI0xh_hA_45TvAQYh9BKrLhlPit18edXEMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/index.vue?macro=true";
import { default as indexlZMtPlsjQO4dc9q6Ym_CuZsWREDDaO_45bKCvfOUNNzxwMeta } from "/opt/buildhome/repo/pages/cathode/capacity-database/index.vue?macro=true";
import { default as precursorQcp_x83GfokouyURfYws_fnQLNKRZK_go9DovuMLkd4Meta } from "/opt/buildhome/repo/pages/cathode/capacity-database/precursor.vue?macro=true";
import { default as sodium_45ion_45cathode8f_gXVdMQWt_45_45ekL_vWQO_nZzs5g_45jFBWgrEnjNLfr0Meta } from "/opt/buildhome/repo/pages/cathode/capacity-database/sodium-ion-cathode.vue?macro=true";
import { default as capacity_45databaseFSnHeDo1aAHeEh_459j1JnM7LaMVkISGj8wffjzQlAVdgMeta } from "/opt/buildhome/repo/pages/cathode/capacity-database.vue?macro=true";
import { default as indexC_rPqjnyehe__45e5AZoDPiqLbJa6F6wjF5hpsvPtlitcMeta } from "/opt/buildhome/repo/pages/events/cathodes2017/index.vue?macro=true";
import { default as hostsWVHpD6g_AafYy5wuZWMDjn6ZAmpVYWMDP4h4sIsMZQEMeta } from "/opt/buildhome/repo/pages/events/graphite2016/hosts.vue?macro=true";
import { default as indexyhEpNOVaEAICgQVzc1cnNDw0CoEWqv42WbUcOvzjEcYMeta } from "/opt/buildhome/repo/pages/events/graphite2016/index.vue?macro=true";
import { default as hostsWGJtz3oFWZmbNW3knE5IrQWk8CIUHt_Hfac64AiOFOIMeta } from "/opt/buildhome/repo/pages/events/graphite2017/hosts.vue?macro=true";
import { default as indexa2zS7fxIQhikwthP9tkYinOJqfKs2i8XbahIipVz7TcMeta } from "/opt/buildhome/repo/pages/events/graphite2017/index.vue?macro=true";
import { default as videoskqyxF7jy9PnZ1jDEqmteQk3hIMh4jMejeUz6SqvZjo0Meta } from "/opt/buildhome/repo/pages/fluorspar/market-insights/videos.vue?macro=true";
import { default as analysisbUlncyfMIlJpLAVvUUVvqehd005v0PgAq38_45HxwNeSIMeta } from "/opt/buildhome/repo/pages/fluorspar/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsy_oQxWsmyAiuOBAoyw4g1KEpIs_PJJ7qjOc5jVMnGjYMeta } from "/opt/buildhome/repo/pages/fluorspar/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsb9dsM_TdtGGMsKBbxHj74YftTzrQmenZmUZ6InEHCNQMeta } from "/opt/buildhome/repo/pages/fluorspar/market-insights.vue?macro=true";
import { default as videos1PrpHdQzU6pnJ9mmu7kUDOl840655uEAh_45_PY_45v8BUUMeta } from "/opt/buildhome/repo/pages/manganese/market-insights/videos.vue?macro=true";
import { default as analysis1KicjvkWw8JC3GGsw_Dhqj9UPe29In9FmNQ0qweCFe0Meta } from "/opt/buildhome/repo/pages/manganese/market-insights/analysis.vue?macro=true";
import { default as critical_45insightss3V52jfdh0dDsdyinmOo5sAk_45gJHHs2r7xSRriYMyg0Meta } from "/opt/buildhome/repo/pages/manganese/market-insights/critical-insights.vue?macro=true";
import { default as market_45insights_gh6CFo9yga2a9KKiHjmZyGUcLfXJUxlG_LMAVFC7w0Meta } from "/opt/buildhome/repo/pages/manganese/market-insights.vue?macro=true";
import { default as videos1qVEKZGjHk_AJmawVd0oeFfZ1KFRSzeCSyi3Rjm_45xXsMeta } from "/opt/buildhome/repo/pages/phosphate/market-insights/videos.vue?macro=true";
import { default as analysisnog_45e13M66QjzZZCWS8uYSXbBabyg5KY7GIX1WEzGDEMeta } from "/opt/buildhome/repo/pages/phosphate/market-insights/analysis.vue?macro=true";
import { default as critical_45insightszCDr_45UCacJc6Mzb_45Rb1x5nqYvzy0r9YoQPWUe3051isMeta } from "/opt/buildhome/repo/pages/phosphate/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsw3spT2DD0X8iDJ9XMUlCW9a7vPewU4fBCPr1XJLevlwMeta } from "/opt/buildhome/repo/pages/phosphate/market-insights.vue?macro=true";
import { default as videosUD9lI68mx_45lPTnTtGeXk_45WBE2jMChlHLIc7ZcTuFTYUMeta } from "/opt/buildhome/repo/pages/recycling/market-insights/videos.vue?macro=true";
import { default as analysisske8hu_45i9MzfTcJIBOq_45Hi3ZLr4ClN0ASh7DC_45EBZTIMeta } from "/opt/buildhome/repo/pages/recycling/market-insights/analysis.vue?macro=true";
import { default as critical_45insights9EQQ4qc2i3C992dsbiDbTcke7KTB3rQKOlfqQblW17wMeta } from "/opt/buildhome/repo/pages/recycling/market-insights/critical-insights.vue?macro=true";
import { default as market_45insights8PI2RbciLA1HlUdv79ciCwpF_pe1VGjfc04t3IVsguMMeta } from "/opt/buildhome/repo/pages/recycling/market-insights.vue?macro=true";
import { default as _91slug_93XVV7pHxh0P2Ub_UWh9eTsKfCB_NIBXrjtwKuupSfVMwMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/[slug].vue?macro=true";
import { default as chartphzVXtDbi_5ZcR_45CGbmUkFqLJ2D2zODv1xZV3StLKj8Meta } from "/opt/buildhome/repo/pages/synthetic-graphite/prices/chart.vue?macro=true";
import { default as index_45JXSe5i9wiyNW_45v7xMDNN2FRY0nOzlAYvEq8gsneMSMMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/prices/index.vue?macro=true";
import { default as _91slug_93fTlU5OeCdw6Aj4Bph5fuN2_45UwfqP1CAmrbvTJpuQqEoMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/prices/[slug].vue?macro=true";
import { default as price_45customisation_45toolbidZOjWILLSf9O9xAW9fB0sEBH2IFSR_9N8INSUz1ckMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/prices/price-customisation-tool.vue?macro=true";
import { default as priceslFCozIzKvzh7HqTQE0hsdOYkBWnrHAvbTg7IecnOoEcMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/prices.vue?macro=true";
import { default as battery_45emissions_45analyserZ_45AxFlxXOwgBcNfHgDJE8jFVMs1jOv8O6CSU8lZWcSMMeta } from "/opt/buildhome/repo/pages/battery-emissions-analyser.vue?macro=true";
import { default as portalLnGbyVnCR5f2OGb2fH7n1GNq2UTqDFNdR0PG3tf78BoMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/portal.vue?macro=true";
import { default as indexLvmBkTpiTYA9_wnzXqYkvNuYiONhwmIJGRs2EiJXAhsMeta } from "/opt/buildhome/repo/pages/events/cathodes-2018/index.vue?macro=true";
import { default as indexw4Tdg2_IpoQiiPwSOHfF_dOfJQnsDRL1ML_45MSLMq48EMeta } from "/opt/buildhome/repo/pages/events/cathodes-2019/index.vue?macro=true";
import { default as agenda_7AZKyDdXJlCWHfrS0xtccibi6Lsyib6_45LINbVXADwwMeta } from "/opt/buildhome/repo/pages/events/cathodes2017/agenda.vue?macro=true";
import { default as agendaIUC900UbCsYQGnhsopmscNFw6a6YYnetEfxTI9SciwcMeta } from "/opt/buildhome/repo/pages/events/graphite2016/agenda.vue?macro=true";
import { default as agendaPgZYLOtop_n9rEYaaS8qCwyryJF3xPdwVjZArG1Bzk0Meta } from "/opt/buildhome/repo/pages/events/graphite2017/agenda.vue?macro=true";
import { default as indexxHXIwol0Ad_IgTja6A0RK44ED2ouyG_IrXY62ZPJY64Meta } from "/opt/buildhome/repo/pages/events/worldtour2017/index.vue?macro=true";
import { default as perthSkNiMrPfKKo_Tvsut79lTYfrni1gLSMopWa5GIZdXAoMeta } from "/opt/buildhome/repo/pages/events/worldtour2017/perth.vue?macro=true";
import { default as seoulhJPxxy_U_0pq9d2BkZhwNDfImahuinH48fCV9O1_zjUMeta } from "/opt/buildhome/repo/pages/events/worldtour2017/seoul.vue?macro=true";
import { default as tokyosQDgW7qqkoNWqJaAc_45WpPjiqq_PLfqjFrOClOKlrz_EMeta } from "/opt/buildhome/repo/pages/events/worldtour2017/tokyo.vue?macro=true";
import { default as lithium_45ion_45battery_45pricesC7337hG89rHVIHeOzQWxQZDF1D4TQYvTQd7hiwRAcvQMeta } from "/opt/buildhome/repo/pages/lithium-ion-battery-prices.vue?macro=true";
import { default as lcaxoFOsuSwKQb8tvTv3nSTqveEln_o_45XRGORB53eTbWPAMeta } from "/opt/buildhome/repo/pages/rare-earths/sustainability/lca.vue?macro=true";
import { default as overviewseruQu25iPLw__ti_WGPGSEtaDBI3DtESohmBWG3OuwMeta } from "/opt/buildhome/repo/pages/rare-earths/sustainability/overview.vue?macro=true";
import { default as sustainability_45indextXXGfoXEGn3iYjzp2POvI_3yJX0KMxp2lZtYB_45e9_BUMeta } from "/opt/buildhome/repo/pages/rare-earths/sustainability/sustainability-index.vue?macro=true";
import { default as sustainability2HKR2AFr0MctOn9CV7vPIu64FRHKsDfB2M6CALsw2qgMeta } from "/opt/buildhome/repo/pages/rare-earths/sustainability.vue?macro=true";
import { default as forecastsM2Exh7WIHeUe14hSTbD7WxwYx3RBA7DCMq6RYdzdUkcMeta } from "/opt/buildhome/repo/pages/silicon-anode/data-reports/forecasts.vue?macro=true";
import { default as data_45reportsoy_45mVMUK_459kR88u5jCE44pYOVS8dpolYgdM4bFXvTCQMeta } from "/opt/buildhome/repo/pages/silicon-anode/data-reports.vue?macro=true";
import { default as agendaS9OPAn_45XS2WZiSLDBp_4575e2yExfEIhvcnnKfVfD1Yt4Meta } from "/opt/buildhome/repo/pages/events/cathodes-2018/agenda.vue?macro=true";
import { default as agendaq3vVigpQn7g5SMMSXsjJ29t_7dSgXTzXHpAMx98IzagMeta } from "/opt/buildhome/repo/pages/events/cathodes-2019/agenda.vue?macro=true";
import { default as indexTFOAvz3lPOj7HYno_9o_45fxOpiwnjzSsSv1C1gGTz3BYMeta } from "/opt/buildhome/repo/pages/events/worldtour-2015/index.vue?macro=true";
import { default as tokyo9oX9QKtqPC8KdhZb_dfM6g_455wvLFhRXL1MA6PbOqOr8Meta } from "/opt/buildhome/repo/pages/events/worldtour-2015/tokyo.vue?macro=true";
import { default as indexKt7aagnUsiJDGPsOrh9epk4uEfLTbgzG_45QJbF7CbvDYMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/index.vue?macro=true";
import { default as tokyotQCGjxfVMN5QxFoekkdecAsI51LBaFDvmv1ufjzWGrsMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/tokyo.vue?macro=true";
import { default as london46g1wU_45UEVzHg_XPcKL_45J0dFfwIpE5K9l0tlyo8ZfY8Meta } from "/opt/buildhome/repo/pages/events/worldtour2017/london.vue?macro=true";
import { default as sydneyD8bboAUDw0nls6qs_45e6PlllVunfUCCcgY9mTUUoun_QMeta } from "/opt/buildhome/repo/pages/events/worldtour2017/sydney.vue?macro=true";
import { default as zurichsbWCvytvAHTu39YYBp6YUBv_YagIIgB1un7IXMO5wrQMeta } from "/opt/buildhome/repo/pages/events/worldtour2017/zurich.vue?macro=true";
import { default as forecastsDaiL_2OV881qCf22HIymn_45wT9AmeHaWlXC4MmJv2d_cMeta } from "/opt/buildhome/repo/pages/new-technology/data-reports/forecasts.vue?macro=true";
import { default as data_45reportsejLkMefl5i_wtXI_45u3LMSPFUwA9WmL5mI8xMm9btwEkMeta } from "/opt/buildhome/repo/pages/new-technology/data-reports.vue?macro=true";
import { default as videos9C950AHA8vq8KkjSEgBZ63RLSMcSv0wjIpdfkKlxnecMeta } from "/opt/buildhome/repo/pages/rare-earths/market-insights/videos.vue?macro=true";
import { default as analysisRkzKQgzK_iTGniALJOXkL2NH2juv_arQ80gUEjzj9tAMeta } from "/opt/buildhome/repo/pages/rare-earths/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsIeRbaUqxZBWpLP09IveEoA6OINVYFInWRb2wgJukTzsMeta } from "/opt/buildhome/repo/pages/rare-earths/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsspHqgPkgSAg4L7Msp0ehClMKAzoudmTrLqcyEn_45ttgcMeta } from "/opt/buildhome/repo/pages/rare-earths/market-insights.vue?macro=true";
import { default as chartaTXhIT6_hAQmVmAUEuTvACXgXm2hY3FyC5nVvvQSLcUMeta } from "/opt/buildhome/repo/pages/recycling/black-mass-prices/chart.vue?macro=true";
import { default as index6PNkphKUs0xAC5idz0vkTJDVQZp_pQ27na3iBzH244AMeta } from "/opt/buildhome/repo/pages/recycling/black-mass-prices/index.vue?macro=true";
import { default as _91slug_93PO3QpZcwMEyVk62yvFFzeWLC_YGd_F1w3sngwH1CM7sMeta } from "/opt/buildhome/repo/pages/recycling/black-mass-prices/[slug].vue?macro=true";
import { default as black_45mass_45prices4pzz_REFyAbbL_3kOWyJaY6t6IEYzCJ2Wkk_45OcgH3BoMeta } from "/opt/buildhome/repo/pages/recycling/black-mass-prices.vue?macro=true";
import { default as locationRf7IDGubhc3CQu_45yJ0oTbgkpAZSqoi4uEEuLGAozwRUMeta } from "/opt/buildhome/repo/pages/events/cathodes2017/location.vue?macro=true";
import { default as sponsorsHy4RwhRSEvrn9Q_45fHsCBFFOsH0qeZSOUPFQ3OPWJpc0Meta } from "/opt/buildhome/repo/pages/events/cathodes2017/sponsors.vue?macro=true";
import { default as locationDbk_tNG67NE5NGQ6xL3cpkRgIJeDwqVl9Mwru5OCYbUMeta } from "/opt/buildhome/repo/pages/events/graphite2016/location.vue?macro=true";
import { default as sponsorsP7rwLWY7K4jv8MTUVgKmhaq56RzTtLJVKR7FmaMGxkQMeta } from "/opt/buildhome/repo/pages/events/graphite2016/sponsors.vue?macro=true";
import { default as locationvC__45KSb3yt6rWwrEc0oIlg8Pc07j3wP2l6T_45rWH86TMMeta } from "/opt/buildhome/repo/pages/events/graphite2017/location.vue?macro=true";
import { default as sponsorsLUwhIKHkOsPejD_k__MrSqFoU3t9qS18IHr1V5IrvjUMeta } from "/opt/buildhome/repo/pages/events/graphite2017/sponsors.vue?macro=true";
import { default as indexu2nwcHQPh_75SVEXwRir9xF9CRiDJYH_45g7COW4pc1wcMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/index.vue?macro=true";
import { default as perth8OF1KLfwtbqv1WIU4aOimR_SOnMoMRM7QrvrbGi5ozEMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/perth.vue?macro=true";
import { default as seoult4bMpHzoHWjWiTJa0lUgo3DvJPhIIc5gegSPs9IK0nMMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/seoul.vue?macro=true";
import { default as tokyoUuNL37_45HSy1EHw8rniTzHshT7dptB1d6SieM6bKK74YMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/tokyo.vue?macro=true";
import { default as indexKix4oIrg34csS0_45RqLJyFBt1JXABtHyQzgbCgrwQtL0Meta } from "/opt/buildhome/repo/pages/events/world-tour-2019/index.vue?macro=true";
import { default as perth9peQjfQy9S20muI_45MTJYrV_xkW_hBTaSYPGnaTlpYksMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/perth.vue?macro=true";
import { default as seoul_45VKzkXjpeo5MBAUPQArEECTpB6ArCR8GS81GEtnMutgMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/seoul.vue?macro=true";
import { default as tokyoVgypQqtgXC_4b6_45d9BloHbj7_45D8Ms7zXcCVx6Vq93K4Meta } from "/opt/buildhome/repo/pages/events/world-tour-2019/tokyo.vue?macro=true";
import { default as indexVs2fOk0pcy8_nbjkd4iATcrObLj2Uo9_45lXos0RIzAx8Meta } from "/opt/buildhome/repo/pages/events/world-tour-2020/index.vue?macro=true";
import { default as indexKmQWuKdcATOGC9L05eaJ1rhDTcdJ1Y4RSscdLByFACkMeta } from "/opt/buildhome/repo/pages/events/world-tour-2022/index.vue?macro=true";
import { default as canadaoIBP5DJjdTpot8pjPmIZAQSAMy79tIqsikQQi8yxiw0Meta } from "/opt/buildhome/repo/pages/events/worldtour-2015/canada.vue?macro=true";
import { default as londonqxjN7p0qvCpdZyUKAfxBgR7rxs85HUkp0VPupf_gvLIMeta } from "/opt/buildhome/repo/pages/events/worldtour-2015/london.vue?macro=true";
import { default as sydneykPeAQ_45XKde3RTeynpb33NU_45g_45r2xDa_45IvZYieUe0qUEMeta } from "/opt/buildhome/repo/pages/events/worldtour-2015/sydney.vue?macro=true";
import { default as canadaImMIQKui_3gAg5CRe7p97aYJ5aBcVSwEMxl5bMYrrhcMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/canada.vue?macro=true";
import { default as londonQ0XwVwqczr3Kwzk8VpF2cIxwfVevciPsz6dkAvOJEZQMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/london.vue?macro=true";
import { default as sydneyUEuo_lg_tOpOXX7oFvPS0TyEJHHtiT3ye7xI2X3HDGoMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/sydney.vue?macro=true";
import { default as beijingPeZyfpVDrkseArgKPAsVaX0Qm8qG3E6LuZf_45DRounH8Meta } from "/opt/buildhome/repo/pages/events/worldtour2017/beijing.vue?macro=true";
import { default as germany3jKq0FDprBqRq_453spjXHbiKR8aZBRO3h5QYeWx3ykwQMeta } from "/opt/buildhome/repo/pages/events/worldtour2017/germany.vue?macro=true";
import { default as newyorkC_tt_Ouff4Kb1bcC8aIZ5BwmKZs28t28eoVOSgu5Fl8Meta } from "/opt/buildhome/repo/pages/events/worldtour2017/newyork.vue?macro=true";
import { default as torontosbf8EFnHLwcH6Faw2bQi_45wIQd_pWO7yo2BVFxSxf6_450Meta } from "/opt/buildhome/repo/pages/events/worldtour2017/toronto.vue?macro=true";
import { default as indexFSENaZFo1bEIsmZ0XLBaWIvt4SNappnhf_sFFh6H3MgMeta } from "/opt/buildhome/repo/pages/events/battery-day-2020/index.vue?macro=true";
import { default as locationYlBVcRJCUm8HpKtqcQPGFShTF8blRUuZUWfdiq1dagAMeta } from "/opt/buildhome/repo/pages/events/cathodes-2018/location.vue?macro=true";
import { default as sponsorsVawCc_45Z3_YSLkwsgPlJ_45oxqfQqfGXxssy7TmHIq38PwMeta } from "/opt/buildhome/repo/pages/events/cathodes-2018/sponsors.vue?macro=true";
import { default as locationmGixmiZnZtN_8aC3GooeYRl_NT72vGPK2q2vBbXAytoMeta } from "/opt/buildhome/repo/pages/events/cathodes-2019/location.vue?macro=true";
import { default as sponsorsiB_vpuAiUBNZme_45tZgixdLRwmPL8bRWUVPt4FZeyoRgMeta } from "/opt/buildhome/repo/pages/events/cathodes-2019/sponsors.vue?macro=true";
import { default as londonyB31TmD8zc0FmY1bjDAlwASg1jBFGvS9Y9xNXdhB5HgMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/london.vue?macro=true";
import { default as sydneyjjgTt3jb_45Xjw42MN9Xdm3jvw7T2nFAPwGZNHQ2MfGYcMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/sydney.vue?macro=true";
import { default as londonbXTSYu7Ad_45pcFnTEnXcOeCr6BVMiYhy505us_BF66N8Meta } from "/opt/buildhome/repo/pages/events/world-tour-2019/london.vue?macro=true";
import { default as sydneyXK4t2demFddVy_45RhoEVUzN5RvPaRGwE0EZuWJb4_BLUMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/sydney.vue?macro=true";
import { default as _91slug_934U_xN2PqHQDnEwt1PRBlC_fz5rEtzIvscFL8q4a9A8QMeta } from "/opt/buildhome/repo/pages/events/world-tour-2022/[slug].vue?macro=true";
import { default as newyorkh24hgjyVSbqUPYd206j46_vA6sYtJsyH50LsPEOh7XMMeta } from "/opt/buildhome/repo/pages/events/worldtour-2015/newyork.vue?macro=true";
import { default as toronto106aHKJ9BkubajVoKxmBJ_YGeSFfUUgcMSU1qivTzqwMeta } from "/opt/buildhome/repo/pages/events/worldtour-2015/toronto.vue?macro=true";
import { default as germanyFL2mzArCoP75148JbI9VvUnIXlZibuDdLtSc6nSsXDwMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/germany.vue?macro=true";
import { default as newyorkw4oaCAMmH5xNvaVi3MJzkNdCGIWy260v5IUqmxrZDAsMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/newyork.vue?macro=true";
import { default as siliconcgDSU_458A_45YEkphMBUW2_455d27J6fBeGBhXt8VyYWOB_4Meta } from "/opt/buildhome/repo/pages/events/worldtour-2016/silicon.vue?macro=true";
import { default as torontoC1JIcXkvCCVQYD_10HpcFMCdL2qYsgBvVJh4w6BkdLUMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/toronto.vue?macro=true";
import { default as hongkongcPDZAQ6Cj8cXht99t7P1PeL4AwiG962ELsHFM32sPx0Meta } from "/opt/buildhome/repo/pages/events/worldtour2017/hongkong.vue?macro=true";
import { default as forecasts_SPAejp_sbgY1blBL15_4533YM98RYIUUUk_45ZUAHicatgMeta } from "/opt/buildhome/repo/pages/natural-graphite/data-reports/forecasts.vue?macro=true";
import { default as sustainabilityuvcVYKUbN7UY4ehckJs4tMq_t_idpFnI7cHQ_4579X2_450Meta } from "/opt/buildhome/repo/pages/natural-graphite/data-reports/sustainability.vue?macro=true";
import { default as price_45assessmentshBFZqzulBQxxANaNYDbac5SZtlaJEkZ4Gomh9q4Dh9oMeta } from "/opt/buildhome/repo/pages/natural-graphite/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportsct7S3OMqT8zEYlfsqMtNMCkdaWi9IGLKzpoBpo1HxvUMeta } from "/opt/buildhome/repo/pages/natural-graphite/data-reports.vue?macro=true";
import { default as chart_45builderlr6t8ngqoqfqxbU9_45N_JoNIGuRJEtxe2Rkb7ZGTJH70Meta } from "/opt/buildhome/repo/pages/price-dashboard/chart-builder.vue?macro=true";
import { default as videosTdoIRuhAzEEndBQvQWKD6V3KB0iuu_4y1dWO4HpZUFoMeta } from "/opt/buildhome/repo/pages/silicon-anode/market-insights/videos.vue?macro=true";
import { default as analysisZmBLceel3q13JNUtuvWS23Kukt9L54_45csgtyxWqNvcYMeta } from "/opt/buildhome/repo/pages/silicon-anode/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsyMzDn1yaPcKFGI_WteHLz_45O9rhf25nMAl3d3DTxsbQ4Meta } from "/opt/buildhome/repo/pages/silicon-anode/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsrcF_0Wg1WNxiJvWTztOLtva9g7fdswL86IwuUxpclkUMeta } from "/opt/buildhome/repo/pages/silicon-anode/market-insights.vue?macro=true";
import { default as chicagoX5HV4OVKVirsuTOgvcUXzMMSkhMRJm2j2CjkS77Q5vgMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/chicago.vue?macro=true";
import { default as germanyn97QjF8rvxxv_45b5zryhQZYHShAWCK7Azagfh7WbmSrIMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/germany.vue?macro=true";
import { default as torontohmvXoTaCTYR_RiI7PS2Kq_45aCAn1670vjL0V2tMjem70Meta } from "/opt/buildhome/repo/pages/events/world-tour-2018/toronto.vue?macro=true";
import { default as chicagoyv25oBUrZQAjjx3Vho_45ZtZNQJ2LUqa_I_yec5J_45dGJ8Meta } from "/opt/buildhome/repo/pages/events/world-tour-2019/chicago.vue?macro=true";
import { default as germanyz3bob9FwRgVFS3nMdEwjopfXzv6qywXX96sl4jaDEXsMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/germany.vue?macro=true";
import { default as torontoUGjWnxrFmDMbfbWuD0CYk0NsbuXOFzoFJlv0f2QR2SIMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/toronto.vue?macro=true";
import { default as indexLf3LPTG8aYbzUgLb8u1iCMpa411mbZMoUkxL7DwFz0sMeta } from "/opt/buildhome/repo/pages/events/world-tour-online/index.vue?macro=true";
import { default as hongkongUsx3P24git6OQgfltB4v_NoueonW0EScorPac7jOkjwMeta } from "/opt/buildhome/repo/pages/events/worldtour-2015/hongkong.vue?macro=true";
import { default as hongkongT5fnDMEG_453RFTKHBeJmK7MEFbf1AjATb1QwTv62IBpcMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/hongkong.vue?macro=true";
import { default as melbourneXE2FQQShA218pVcpfIprWlxYmoSHrrBg96XfCbH4aecMeta } from "/opt/buildhome/repo/pages/events/worldtour2017/melbourne.vue?macro=true";
import { default as vancouvermq0uXeedxmqHELt4MgTvv6_rJCOzu9NrvipEOe9iKDkMeta } from "/opt/buildhome/repo/pages/events/worldtour2017/vancouver.vue?macro=true";
import { default as videoscK9da_9Rv1JIraHrzZA8ghJvJGTMq31OCg_Dae7FUB4Meta } from "/opt/buildhome/repo/pages/new-technology/market-insights/videos.vue?macro=true";
import { default as analysis8_my2XChk3PRA2DFDPU25MVWnlyfHcfS26py0ZFGvNkMeta } from "/opt/buildhome/repo/pages/new-technology/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsiViy2OdOhzByJJAKXJTFIkn4__SN_453OZZJR11vJRkXsMeta } from "/opt/buildhome/repo/pages/new-technology/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsNIP2_WMMsEu6qVV09yRbomxPXR5CMjup8MqY0SRQyJkMeta } from "/opt/buildhome/repo/pages/new-technology/market-insights.vue?macro=true";
import { default as _91id_932ttV3F0SuVBw0tXLyLFOtjM6sg6OatpxohoiTnci_459oMeta } from "/opt/buildhome/repo/pages/price-dashboard/watchlist/[id].vue?macro=true";
import { default as field_45trip2sdek_45dWnroJts5AgNekhiYK2CuTsCsNwddFEq7ptVQMeta } from "/opt/buildhome/repo/pages/events/cathodes-2019/field-trip.vue?macro=true";
import { default as new_45yorkSPqV__45n0EsO5JaTZiTQDGl5uI8vY1TXC_457tYvhXNHGAMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/new-york.vue?macro=true";
import { default as adelaidepwJC_45T1tyNVLW958wj_453dKdUgFHVLqnIQTF8SYrFdcwMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/adelaide.vue?macro=true";
import { default as new_45yorkDQOKUeOLCudAsC5pXqb03SKHmowyEHaFH5BVTXCjxUEMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/new-york.vue?macro=true";
import { default as melbourneoElkDhDcD7vtQTB7U4_9NSz6K9ke_YjeUEDpZsCAJjYMeta } from "/opt/buildhome/repo/pages/events/worldtour-2015/melbourne.vue?macro=true";
import { default as melbourneYIkMjJCvKaInI2JqlRt16SVoLttWs03lKyT9cdKcPGwMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/melbourne.vue?macro=true";
import { default as lca50Mu2Us9_tmSXZljHPCgg_45BjA9WEbwvncEJCiGR4lVsMeta } from "/opt/buildhome/repo/pages/natural-graphite/sustainability/lca.vue?macro=true";
import { default as overviewcC3cqKqf8KKcWNYve6_45HkSlffqxhMm_45BczOEaJ_45IdBcMeta } from "/opt/buildhome/repo/pages/natural-graphite/sustainability/overview.vue?macro=true";
import { default as sustainability_45indexneUZ52JNw0BJFtrEL_45_09xeBBVporaptGY2Nw3sXtOUMeta } from "/opt/buildhome/repo/pages/natural-graphite/sustainability/sustainability-index.vue?macro=true";
import { default as battery_45emissions_45analyserCeC_R_604avO_ZNKVCEFYFAZEkJ95uF3TRloiMbGkEoMeta } from "/opt/buildhome/repo/pages/natural-graphite/sustainability/battery-emissions-analyser.vue?macro=true";
import { default as sustainabilityGGHxoVd9mBBqCtPJnKLN7N6vecP_SPO8Paoh97L9_ZUMeta } from "/opt/buildhome/repo/pages/natural-graphite/sustainability.vue?macro=true";
import { default as index1WsTlVhvhQXMTPMtibJk3sjemyv9V0NKZyWp60MzQjYMeta } from "/opt/buildhome/repo/pages/price-dashboard/watchlist/index.vue?macro=true";
import { default as forecastsQm8J_45GWfyJ7deQCfAUrCYzf5LMse25QvHneyLoDvwoMMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/data-reports/forecasts.vue?macro=true";
import { default as sustainabilityo1ipOGWYHkIxbq13M1YqwqjAYRSWQ7GMGu9ONtxN71oMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/data-reports/sustainability.vue?macro=true";
import { default as price_45assessmentsVOv21o3fPLQb4GrRovYMBKr49WQs6JJ5VxAv0uLnTCAMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportsYcFdpkhIbSlj7hLqpSADre_45QBo101OsUQisv2cOnk5IMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/data-reports.vue?macro=true";
import { default as forecasts69Zg4JpnM7U13Ja3EF2xvczl8ybgDxzmqF_45xj2ZBT1sMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/data-reports/forecasts.vue?macro=true";
import { default as price_45assessmentsc4DuL6Qtq9BG9DQCvAtedEoo_45IsZeClGR9o4XPV1acIMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/data-reports/price-assessments.vue?macro=true";
import { default as market_45assessmentsTptWk9rthyQqHXf7fNV6u8m_45I14vkrvEM4syvhqVLJ8Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/data-reports/market-assessments.vue?macro=true";
import { default as data_45reports_45c9ylmhlcPihaO_45UN6rUaOfrxyNqFsLkBVeAnKWJD_45wMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/data-reports.vue?macro=true";
import { default as site_45visitsY531jZrOVycxllCVGSw4X6XYs7e_45bRSenidNExsGdBoMeta } from "/opt/buildhome/repo/pages/events/cathodes-2018/site-visits.vue?macro=true";
import { default as hong_45kongtsRMAE7KAxcizTg05lbYbQvhkdM616R5DtaqbLN3piwMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/hong-kong.vue?macro=true";
import { default as melbourneibheQF7YhXysXmgo9NdG5RGcmtvS3cFGtIHT4mFzQr0Meta } from "/opt/buildhome/repo/pages/events/world-tour-2018/melbourne.vue?macro=true";
import { default as vancouverR_45xmmaqTirELVnwgjj_XK1oXgoS_CWRqK0UtWc_mYTYMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/vancouver.vue?macro=true";
import { default as cape_45townwVzttEpFJNVzTZ3lvgcS2nj712ox2e6Hlelx4XsMf7YMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/cape-town.vue?macro=true";
import { default as hong_45konguhSRQ5FErWpq6QRmKsjAg8lFBIf6ugNbtcgShZy6ZXwMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/hong-kong.vue?macro=true";
import { default as melbourneEepzrJ9gTxCKPHLSjSLxHS6x59O8muEz7HNnp0_5bvYMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/melbourne.vue?macro=true";
import { default as vancouverK_Rdm1YeU45RkKCeV7xjhIxm2aHhBrxLYTezztQQaEQMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/vancouver.vue?macro=true";
import { default as washingtonn_45CEBhNTTyGMtKwzzzp3WfDUGM2gb8dDSjrrfaevHbcMeta } from "/opt/buildhome/repo/pages/events/worldtour-2016/washington.vue?macro=true";
import { default as indexSDuNML839Vz10m7zw4Mv16hkDjKbX93eWioA5EEnNv8Meta } from "/opt/buildhome/repo/pages/lifetime-achievement-award/index.vue?macro=true";
import { default as videos8QQy85x165BbCeXcjr_4FYnS0DMZjbWeVzMSFuChhvYMeta } from "/opt/buildhome/repo/pages/natural-graphite/market-insights/videos.vue?macro=true";
import { default as analysisD_2hag6U4b16g_4J6zS2fOioEWxDIRmABco91ldFCA8Meta } from "/opt/buildhome/repo/pages/natural-graphite/market-insights/analysis.vue?macro=true";
import { default as critical_45insights3pn3HKWcEYwzKeGauhpfFZqls6Tz7Wh3p7l8ZImrhXQMeta } from "/opt/buildhome/repo/pages/natural-graphite/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsHrfjydOf4OFO5Paxo7ZdBXmqTKdzdddYI3IxouRBmzEMeta } from "/opt/buildhome/repo/pages/natural-graphite/market-insights.vue?macro=true";
import { default as new_45york_452CpFHyPAxvmz_MGW5wZ_zlPhYz2DjNAG7ZSm19JpMnf8Meta } from "/opt/buildhome/repo/pages/events/world-tour-2019/new-york-2.vue?macro=true";
import { default as washingtondcbOW0W9q8E6XkQTZuFqe9ZpOcRB79BhviVSrKTXC_45YdEMeta } from "/opt/buildhome/repo/pages/events/worldtour2017/washingtondc.vue?macro=true";
import { default as lcaWQ_XjzbRRtMQwsQF0LHMeae9bZ3v_45fALPuLApiQCwDMMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/sustainability/lca.vue?macro=true";
import { default as overview97z0CWhh8uCHPkjuvl2_ybGPIyikIOwXw6CIwzlrJSMMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/sustainability/overview.vue?macro=true";
import { default as sustainability_45indexe7ePvFcIuRqxtG_TffLK5P3H8_456uFjk3iDHIvOFly6QMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/sustainability/sustainability-index.vue?macro=true";
import { default as battery_45emissions_45analyserbRvYGu8mnd2FhG4G1HWKnyL5ZkFDEkjV3nNWob5y7k0Meta } from "/opt/buildhome/repo/pages/synthetic-graphite/sustainability/battery-emissions-analyser.vue?macro=true";
import { default as sustainabilityguROWt1ceEKfHogtidtK22y6_45eZY0WJ_IETmEKd7umQMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/sustainability.vue?macro=true";
import { default as overviewPorE21G2DcJvXbC2zB9xGLjikG45aEENrm_5mGcJqQQMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/sustainability/overview.vue?macro=true";
import { default as battery_45emissions_45analyserCbZyhGlfVk43_45UYSJRmFk0IGrb2iEvlhlQLRmNEEuRMMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/sustainability/battery-emissions-analyser.vue?macro=true";
import { default as sustainabilityXSUHVPWj6msca7IkXe0809IigjfGwkLPkl7EBE6mnY4Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/sustainability.vue?macro=true";
import { default as videosFgYARxTX82gCmew1FsOwNF_PD5tMFd_45W3SOESwCgKmQMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/market-insights/videos.vue?macro=true";
import { default as analysisJyYEHqLSh7FoHIGE00oRhBazBnfdW2tZto1tIkA2OWkMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/market-insights/analysis.vue?macro=true";
import { default as critical_45insightstENqEa19jEQuKHTejOqETWAHiowVRpPu71T6Np63y_45MMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/market-insights/critical-insights.vue?macro=true";
import { default as market_45insights6jpXxHyGG6Wo2TGR5uGwUrgWebwVVe9LahhJwKn2NPsMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/market-insights.vue?macro=true";
import { default as videosNp3LGbSz_45Fi6zHbglRQS3bNCUb3YVdPFqGCRfR_45fWW8Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/market-insights/videos.vue?macro=true";
import { default as analysisvnlDS022c5PHjBlNjjxYMqlAJxXJOXbdrrzTaMduP_45IMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsW6vfrvQHX60i_45O_45_45HDRLK9BUT998DerUIDSqTAvCwBMMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsABYc_45XgLcXtzZITJL4UiDb7H_45bwv81_45qChYCBr4ZH3sMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/market-insights.vue?macro=true";
import { default as london_45day_452F6rhh6Jbzs_45NRnhioqyh8DDJCSlUdEtpDdQOSVB3_XYMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/london-day-2.vue?macro=true";
import { default as san_45franciscoVWE82EOZaSBJnowvexbAw7RCeCrdxF_HW_896u738_AMeta } from "/opt/buildhome/repo/pages/events/world-tour-2018/san-francisco.vue?macro=true";
import { default as san_45franciscoSqm_45_Jlq1ROjETpl1bHm1dESMIdmubxE2_JhJKcGixIMeta } from "/opt/buildhome/repo/pages/events/world-tour-2019/san-francisco.vue?macro=true";
import { default as indexBlR3koxPdeiuXWb4O0X_IasfaD6FoYz2u111LdRFRuwMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/index.vue?macro=true";
import { default as battery_45cellzh_lsHvarVb1FIm6dRcach7u1RCj9gm7i2E_45CUHdUw0Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/battery-cell.vue?macro=true";
import { default as sodium_45ion_45capacitiesrTNtQAlnQH2cwCm2t2EI4gJx5DYeCatPtZORHc2ZXhkMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/sodium-ion-capacities.vue?macro=true";
import { default as capacity_45databaseco42LG5QtrGnwlJrYDpDh7uiRmc17mtK4jSLOnCwHKcMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/capacity-database.vue?macro=true";
import { default as index2qVAMJ_NrkHrQqkq7RSJXkR0lblKbAicKDGU8X6D3EsMeta } from "/opt/buildhome/repo/pages/events/graphite-and-anodes-2018/index.vue?macro=true";
import { default as index0saDhqIhvfZ42Ydk_459_45gQ1DmXaR7cxR28gzMYlKmarIMeta } from "/opt/buildhome/repo/pages/events/graphite-and-anodes-2019/index.vue?macro=true";
import { default as index18FLPAhs6F1sFGfGAt51ZmAsQyAjAC_45UZmTZaZUYm8sMeta } from "/opt/buildhome/repo/pages/events/world-tour-2023-new-york/index.vue?macro=true";
import { default as agenda6gejJwarL9yUj87e1d2ZMsY6nDmD9QfhmG5RkIJaAvAMeta } from "/opt/buildhome/repo/pages/events/graphite-and-anodes-2018/agenda.vue?macro=true";
import { default as agendaRoygJrgKF_45CUq4UB3dol0jgT1NXIBQOVKxwNPsWIZQ0Meta } from "/opt/buildhome/repo/pages/events/graphite-and-anodes-2019/agenda.vue?macro=true";
import { default as jb_45straubelrGSk2rznqbcAmzrIpyyfZbCm_VNq_459XGT_G8uADjqJMMeta } from "/opt/buildhome/repo/pages/lifetime-achievement-award/jb-straubel.vue?macro=true";
import { default as lithium_45ion_45battery_45raw_45material_45indexj5UMCe6WWpgB4wkPoq7JiJo_XUDFu_1H7mVVqJXXVcsMeta } from "/opt/buildhome/repo/pages/lithium-ion-battery-raw-material-index.vue?macro=true";
import { default as _91slug_93heVwQMxM7oBtx9IE13k4sjtckMcfaSNaH5FG1hfwFfwMeta } from "/opt/buildhome/repo/pages/lithium-price-assessment-portal/[slug].vue?macro=true";
import { default as benchmark_45statementsbm7nzuJGLmItZUTXsVSZRh8pEqvXJb_J3Wp2JAihpEEMeta } from "/opt/buildhome/repo/pages/price-assessments/benchmark-statements.vue?macro=true";
import { default as indexGmKyFhwIVNq7_UYopROXytbhIq4VNoFs25AVMXWvskoMeta } from "/opt/buildhome/repo/pages/events/benchmark-week-online-2021/index.vue?macro=true";
import { default as indexLKNcEHi9krQyUUFbezdWO1G36WmicLs_450nwH6KyxKdgMeta } from "/opt/buildhome/repo/pages/[market]/market-insights/briefings/index.vue?macro=true";
import { default as locationfHvzYiqSBNgwlEFDXBRKXSC79oROI5S3YTxj4cQmMPEMeta } from "/opt/buildhome/repo/pages/events/graphite-and-anodes-2018/location.vue?macro=true";
import { default as sponsorsdVGHs41qJDySgts0mFFbuCcE_71KeIw9hifjnsmMY6oMeta } from "/opt/buildhome/repo/pages/events/graphite-and-anodes-2018/sponsors.vue?macro=true";
import { default as locationZCLsExoAnX7_CXMNH41Y80rLc3ko2TRLtX4VMCOiRSIMeta } from "/opt/buildhome/repo/pages/events/graphite-and-anodes-2019/location.vue?macro=true";
import { default as sponsorsGr96E8jEIoCuc3eH7UXvDHCVKxexrIclcQOw00AqDXIMeta } from "/opt/buildhome/repo/pages/events/graphite-and-anodes-2019/sponsors.vue?macro=true";
import { default as all_45prices_45subscription6lIT6cM0wNj_45YWrawprnSxgoHMPdBrOqT0XYQTDLp6AMeta } from "/opt/buildhome/repo/pages/price-assessments/all-prices-subscription.vue?macro=true";
import { default as indextmm5KC06egn2yyVmleJDJ_456gKh8e94f4ZT7E1zAVKuEMeta } from "/opt/buildhome/repo/pages/events/benchmark-lithium-summit-2018/index.vue?macro=true";
import { default as independent_45practitioners_45assurance_45reportT9MO1nMykYjO3I3zbUTfvVcFbC6rf7E9PFhvjVdwRacMeta } from "/opt/buildhome/repo/pages/independent-practitioners-assurance-report.vue?macro=true";
import { default as indexvYrC2qbr91b0W9VxTA04axkp_q2KZi0zYeSogOh3FGgMeta } from "/opt/buildhome/repo/pages/events/battery-gigafactories-usa-2022/index.vue?macro=true";
import { default as indexKj_b_HPwcBjM_45kE7PGjm8Opzu4XUVDx3oA29gaM9JigMeta } from "/opt/buildhome/repo/pages/events/benchmark-minerals-summit-2020/index.vue?macro=true";
import { default as indexSALPiWOBzrdzrxoNvHu0Nv3ClZCA4ycsWiAOgygUqgAMeta } from "/opt/buildhome/repo/pages/events/battery-megafactories-europe-2022/index.vue?macro=true";
import { default as stanley_45whittingham0Gk7RiHK_e28dCsQSH8gJzwegOJsaUhEpT3BfcaACAoMeta } from "/opt/buildhome/repo/pages/lifetime-achievement-award/stanley-whittingham.vue?macro=true";
import { default as chart9Vq24jqjf6ycod09reGJLcmT8DeOZXfOihrIjrdqDx8Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/chart.vue?macro=true";
import { default as indexXW_73qxVw_45AO29bMNzSXAJK3RU89H68LA6Ix9p64_q0Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/index.vue?macro=true";
import { default as _91slug_93M9Fp0dxzKsebaAaHG0un8dU2nR0q35p8o0UmJs4ToLMMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/[slug].vue?macro=true";
import { default as lithium_45ion_45batteries_45pricesc1qoYTLD6ULkoQ9aBDx2jBIgxAocVkssX6d_FvP4VS0Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices.vue?macro=true";
import { default as arnold_45schwarzeneggertePbj8aEs4vMRonEqEeWZ_45PWqhdsS59mbMETgLDAbwkMeta } from "/opt/buildhome/repo/pages/lifetime-achievement-award/arnold-schwarzenegger.vue?macro=true";
import { default as locationvwAAxgk_sBdpwKibRWT5Hhe3pXp_45R4ICNyJGypdHsocMeta } from "/opt/buildhome/repo/pages/events/battery-megafactories-europe-2022/location.vue?macro=true";
import { default as _91slug_93Y5plBC6ZUhGMGhBd8Lp7bSnvWV0jWvdbNzLNGMmkPq8Meta } from "/opt/buildhome/repo/pages/[market]/market-insights/briefings/[category]/[slug].vue?macro=true";
import { default as _91id_93aHRD_45C62bpxQlXiJyTO0jL2I7qPg_pOCc0_xNnliX94Meta } from "~/custom-pages/[market]/data-reports/[subCategory]/video/[id].vue?macro=true";
import { default as _91id_93fW65Rf0tLwtKeru2QgILXBNROxdqKSkj74UAHmNka1IMeta } from "~/custom-pages/[market]/data-reports/[subCategory]/report/[id].vue?macro=true";
import { default as _91id_935fjG9iKCprPRoUGUgPHbl5pkqVS5lZAMFE6hwtlKstQMeta } from "~/custom-pages/[market]/data-reports/report/[id].vue?macro=true";
import { default as lithium_45futuresZERWYi4q28x9pNlGiAO46RCSZeUolKXHSqbNbv7ZrkwMeta } from "~/custom-pages/lithium/lithium-prices/lithium-futures.vue?macro=true";
import { default as cobalt_45futuresRNa5wvzfNh5T1kHYvRWOEh26Q8runxo819R9tUq7MRoMeta } from "~/custom-pages/cobalt/cobalt-prices/cobalt-futures.vue?macro=true";
export default [
  {
    name: "app",
    path: "/app",
    component: () => import("/opt/buildhome/repo/pages/app.vue")
  },
  {
    name: "lca",
    path: "/lca",
    component: () => import("/opt/buildhome/repo/pages/lca.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/buildhome/repo/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "join-us",
    path: "/join-us",
    component: () => import("/opt/buildhome/repo/pages/join-us.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "api-docs",
    path: "/api/docs",
    meta: docsEKVsNapdpIlFGo3bfL4dYZ_mE3e_fauyU9DHvkGHV8EMeta || {},
    component: () => import("/opt/buildhome/repo/pages/api/docs.vue")
  },
  {
    name: "api",
    path: "/api",
    component: () => import("/opt/buildhome/repo/pages/api/index.vue")
  },
  {
    name: "forecasts",
    path: "/forecasts",
    meta: { ...(forecaststgunpIcSaZpZ4TfLMX5PMTlV1KctEgn6dgS_450IQgx5MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/forecasts.vue")
  },
  {
    name: "anode",
    path: "/anode",
    meta: indexV1Vws_UfiOV_7sHFbNbhAoB31BXf8h7WyoPlqeXIC64Meta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/index.vue")
  },
  {
    name: "consultancy",
    path: "/consultancy",
    component: () => import("/opt/buildhome/repo/pages/consultancy.vue")
  },
  {
    name: "events-past",
    path: "/events/past",
    meta: pastjTbKywpKi8BA0VR_fbnTpgIBxyAqP8Zt3gOyqrdVQWwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/past.vue")
  },
  {
    name: "newsletters",
    path: "/newsletters",
    component: () => import("/opt/buildhome/repo/pages/newsletters.vue")
  },
  {
    name: pricesDSzs09F6ZLCQG29ymFDVPdlUYwfZF2Nb_45vKSwmRRZIgMeta?.name,
    path: "/anode/prices",
    meta: pricesDSzs09F6ZLCQG29ymFDVPdlUYwfZF2Nb_45vKSwmRRZIgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/prices.vue"),
    children: [
  {
    name: "anode-prices-chart",
    path: "chart",
    meta: chartr3rn9Yk43VA8DzQ_z_T3HnuWuphPADYLyfp5oSyh05MMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/prices/chart.vue")
  },
  {
    name: "anode-prices",
    path: "",
    meta: index26PnRex5Ak_45suLiH_k1HIoTKaRdogouS8VDlq8H6_twMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/prices/index.vue")
  },
  {
    name: "anode-prices-slug",
    path: ":slug()",
    meta: _91slug_93mKuO3HkhKWZn6x6Q8Gu6BUJs2NtedYnBD1gszUDIXYwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/prices/[slug].vue")
  }
]
  },
  {
    name: "cobalt",
    path: "/cobalt",
    meta: indexrKE5y1yBe1MpZTdEG_BdH_45IQpYwRVi8dC_45Ng_vJIENgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/index.vue")
  },
  {
    name: "copper",
    path: "/copper",
    meta: { ...(indexgV5H6VL612U6jL27JLgYyHNXmWydn7yq_TtYYRMF9bEMeta || {}), ...{"middleware":["premium-market-guard"]} },
    component: () => import("/opt/buildhome/repo/pages/copper/index.vue")
  },
  {
    name: "events",
    path: "/events",
    meta: indexU0mRl8BtPWRyVs9v9mXNnL0sIofcrekH7VHBkj_OTTUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/index.vue")
  },
  {
    name: "excel-add-in",
    path: "/excel-add-in",
    component: () => import("/opt/buildhome/repo/pages/excel-add-in.vue")
  },
  {
    name: "nickel",
    path: "/nickel",
    meta: indexEi_45Uknbeg1CgFFca_45L5Ydki7XdS_u5UGtocjRA2uofIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/index.vue")
  },
  {
    name: "set-password",
    path: "/set-password",
    component: () => import("/opt/buildhome/repo/pages/set-password.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: { ...(indexsSHEynImpmVJQBsgEWtpFbTIimvAlNbjHy0W37sieOIMeta || {}), ...{"middleware":["authenticated"]} },
    component: () => import("/opt/buildhome/repo/pages/account/index.vue")
  },
  {
    name: "cathode",
    path: "/cathode",
    meta: indexD2PZM2i5TGsluOtSKKcrPDVQJiZyp5yh9fbCRp_pA1AMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/index.vue")
  },
  {
    name: "cobalt-slug",
    path: "/cobalt/:slug()",
    component: () => import("/opt/buildhome/repo/pages/cobalt/[slug].vue")
  },
  {
    name: prices2RRxBXMGU9iWoiPD1IuYW2q9wdb2oe_GC4W6ZkGqDaUMeta?.name,
    path: "/cobalt/prices",
    meta: prices2RRxBXMGU9iWoiPD1IuYW2q9wdb2oe_GC4W6ZkGqDaUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/prices.vue"),
    children: [
  {
    name: "cobalt-prices-chart",
    path: "chart",
    meta: chartSoJMXbTvAjQCxJpXZgcYUAFZOzPeLumyP7Fde72GTMUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/prices/chart.vue")
  },
  {
    name: "cobalt-prices",
    path: "",
    meta: index1zfBnW0cRNv2eN29gwDOZs687CfLKFF3hUqzmCTHh98Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/prices/index.vue")
  },
  {
    name: "cobalt-prices-slug",
    path: ":slug()",
    meta: _91slug_93SJ5YyTlImcrhEYlKVSHCPye9ceo9bFaiVea9rSDaXhUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/prices/[slug].vue")
  },
  {
    name: "cobalt-prices-price-customisation-tool",
    path: "price-customisation-tool",
    meta: price_45customisation_45tooltced3pSYcJYm7TG_45053B0Rd3de1hsJbyT4bXCsigDaQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/prices/price-customisation-tool.vue")
  }
]
  },
  {
    name: "copper-weekly",
    path: "/copper-weekly",
    component: () => import("/opt/buildhome/repo/pages/copper-weekly.vue")
  },
  {
    name: "copper-portal",
    path: "/copper/portal",
    meta: portalQkWIVq9Q4LTJk7nfExKm1JsGTo6pTCcDLoEZyunm3mEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/portal.vue")
  },
  {
    name: "events-slug",
    path: "/events/:slug()",
    meta: _91slug_93iBWtnnrkRuyTsyx2RmfgEUrnQhbG8tPVQVaeOSmBPMcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/[slug].vue")
  },
  {
    name: "lithium",
    path: "/lithium",
    meta: indexa8TZF5gFe8ppoZ05hiQiyaVGnNlztxvIaHmUgRiahtIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/index.vue")
  },
  {
    name: "nickel-slug",
    path: "/nickel/:slug()",
    component: () => import("/opt/buildhome/repo/pages/nickel/[slug].vue")
  },
  {
    name: pricesGLmo5Hyj3LNYlaN4s8_45JlstKyn3k29jrlBcYww8ntVcMeta?.name,
    path: "/nickel/prices",
    meta: pricesGLmo5Hyj3LNYlaN4s8_45JlstKyn3k29jrlBcYww8ntVcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/prices.vue"),
    children: [
  {
    name: "nickel-prices-chart",
    path: "chart",
    meta: chart2HN2eqxHhuHGKdqUtY7zzNFP3lIT_9JAvisFTbkvnp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/prices/chart.vue")
  },
  {
    name: "nickel-prices",
    path: "",
    meta: indexyl_45OzeNbqkwSta3hmXexzhQfmWKBjAQ_ymbIP1CuxzwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/prices/index.vue")
  },
  {
    name: "nickel-prices-slug",
    path: ":slug()",
    meta: _91slug_93fk0slPu7RgEO8MO1aawZkiUeCtGOU8li47DkB8qUKgUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/prices/[slug].vue")
  },
  {
    name: "nickel-prices-price-customisation-tool",
    path: "price-customisation-tool",
    meta: price_45customisation_45tool2CPFVSdlSq5gxrCi41fTk8IZrLTX5xVayu8KvFumXt0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/prices/price-customisation-tool.vue")
  }
]
  },
  {
    name: pricesfuwmmz7gcD24VAxvHEUL_45wZuOtwCkWu3ZygmjyvQGHwMeta?.name,
    path: "/cathode/prices",
    meta: pricesfuwmmz7gcD24VAxvHEUL_45wZuOtwCkWu3ZygmjyvQGHwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/prices.vue"),
    children: [
  {
    name: "cathode-prices-chart",
    path: "chart",
    meta: chartg8b0cCAjfokZMR0k7H5g41bJ3mPHMfG3xqHj1I312BsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/prices/chart.vue")
  },
  {
    name: "cathode-prices",
    path: "",
    meta: indexnvKBJb1g0UuHHc1HMLtXSpMGhp2uHP85xJo5KtEAAVYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/prices/index.vue")
  },
  {
    name: "cathode-prices-slug",
    path: ":slug()",
    meta: _91slug_93gFnDl6WQqejdL_IDw3NOYyQGINkXV2IYYUzNpo4uJE4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/prices/[slug].vue")
  }
]
  },
  {
    name: "events-summits",
    path: "/events/summits",
    meta: summitsl52L_45hp7I_45_TCKNs0NFQtB5HLSOZ7AXzfsE_ZabosmsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/summits.vue")
  },
  {
    name: "lithium-prices-page",
    path: "/lithium-prices",
    meta: lithium_45pricesytpkbQHbYuW_45iLVc2_lFLPW5zveuYVFC_Z5pxrHCda8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium-prices.vue")
  },
  {
    name: "lithium-slug",
    path: "/lithium/:slug()",
    component: () => import("/opt/buildhome/repo/pages/lithium/[slug].vue")
  },
  {
    name: "lithium-prices-nested",
    path: "/lithium/prices",
    meta: pricesr04WsZVosMYNPTGibZ9vrj0RPEfb74rVl8gFiKVWz9MMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/prices.vue"),
    children: [
  {
    name: "lithium-prices-chart",
    path: "chart",
    meta: charteL_ZgnPhxhgSBK4GsjTlFu_ehPBPpDJwg1K8_454R41sEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/prices/chart.vue")
  },
  {
    name: "lithium-prices-index",
    path: "",
    meta: index5RgLDA_w9cQRH1inImhoGpSVl2CsHinA3oF4agwFdMsMeta || {},
    alias: ["table"],
    component: () => import("/opt/buildhome/repo/pages/lithium/prices/index.vue")
  },
  {
    name: "lithium-prices-slug",
    path: ":slug()",
    meta: _91slug_9376Ef1pqhSPK3MZz2fN_45203gkNSSiose3PP63yAmbnoEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/prices/[slug].vue")
  },
  {
    name: "lithium-prices-price-customisation-tool",
    path: "price-customisation-tool",
    meta: price_45customisation_45tooliq2dWHKcC7_XbP6xYy00RJIlmy31IOKaZd7PpdUisUEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/prices/price-customisation-tool.vue")
  }
]
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "sustainability",
    path: "/sustainability",
    meta: { ...(sustainability_452inpZEfBkqcylTucQFeGv6X_r5_458dtUHpKmzvnZrUQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/sustainability.vue")
  },
  {
    name: "events-webinars",
    path: "/events/webinars",
    meta: webinarsmdW5CUPTHXNSWXYTk1SoBN5F57_45wmmLe8kOeNFxqrn8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/events/webinars.vue")
  },
  {
    name: "fluorspar",
    path: "/fluorspar",
    meta: index7ldmIiBtJcKUbnfUx1KhOMc7CkkdFfkXrATN7i4bpkEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/index.vue")
  },
  {
    name: "manganese",
    path: "/manganese",
    meta: indexfTjnSj5ZaZDm6sPT15BVMjUZ_jS6KmFryaTAN9d_45F4oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/index.vue")
  },
  {
    name: "phosphate",
    path: "/phosphate",
    meta: indexX_45km_45nzcK8KTn2OSWLYqrEQrtgWpHsGfisnHF3fteV0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/index.vue")
  },
  {
    name: "recycling",
    path: "/recycling",
    meta: { ...(indexiHP_459aTnVcuNachfyBCN79XBQffLB7okl91Zmpui_45EkMeta || {}), ...{"middleware":["premium-market-guard"]} },
    component: () => import("/opt/buildhome/repo/pages/recycling/index.vue")
  },
  {
    name: "forms-stellantis",
    path: "/forms/stellantis",
    component: () => import("/opt/buildhome/repo/pages/forms/stellantis.vue")
  },
  {
    name: "industry-reports",
    path: "/industry-reports",
    component: () => import("/opt/buildhome/repo/pages/industry-reports.vue")
  },
  {
    name: "recycling-slug",
    path: "/recycling/:slug()",
    component: () => import("/opt/buildhome/repo/pages/recycling/[slug].vue")
  },
  {
    name: "recycling-portal",
    path: "/recycling/portal",
    meta: portalkwOl_lOUEv830UjhBpD7MvDLyfTP_l_Mrpx4ua521xYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/portal.vue")
  },
  {
    name: "membership-slug",
    path: "/membership/:slug()",
    component: () => import("/opt/buildhome/repo/pages/membership/[slug].vue")
  },
  {
    name: "newsletter-signup",
    path: "/newsletter-signup",
    component: () => import("/opt/buildhome/repo/pages/newsletter-signup.vue")
  },
  {
    name: "policy-newsletter",
    path: "/policy-newsletter",
    component: () => import("/opt/buildhome/repo/pages/policy-newsletter.vue")
  },
  {
    name: "rare-earths",
    path: "/rare-earths",
    meta: indexAXftbV7OCVl2z5M2zjEzZx8dInE_45rT3_BIygGoNXNEUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/index.vue")
  },
  {
    name: "account-api-access",
    path: "/account/api-access",
    meta: { ...(api_45accessPwZoObqN_o4XW0cPBPJfLl3QkAXdTVdAB4daz7PSOfUMeta || {}), ...{"middleware":["authenticated"]} },
    component: () => import("/opt/buildhome/repo/pages/account/api-access.vue")
  },
  {
    name: "anode-data-reports",
    path: "/anode/data-reports",
    meta: data_45reportsBY_xoXIpCtAQVdXM56XZdxB8pUJYgrDgTKJiYX6GZ6EMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/data-reports.vue"),
    children: [
  {
    name: "anode-data-reports-forecasts",
    path: "forecasts",
    meta: forecasts3IvqGGprpUYGk5jhOVbHxacCEOarLvy77lvyeYrpZO4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/data-reports/forecasts.vue")
  },
  {
    name: "anode-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsPWvhULnhXknsD4_45gy15GT4vXVs2V6i6NiotM3It0JGUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "market-assessments",
    path: "/market-assessments",
    meta: { ...(market_45assessmentsm60EINFruAvWvHY5EGL8s4ccZgnAwUL8fnXGLEcMlScMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/market-assessments.vue")
  },
  {
    name: "rare-earths-slug",
    path: "/rare-earths/:slug()",
    component: () => import("/opt/buildhome/repo/pages/rare-earths/[slug].vue")
  },
  {
    name: pricesVhUiI68Gm9juvXqkg8W919ZjqghBWqxKglQ8B2FAU6oMeta?.name,
    path: "/rare-earths/prices",
    meta: pricesVhUiI68Gm9juvXqkg8W919ZjqghBWqxKglQ8B2FAU6oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/prices.vue"),
    children: [
  {
    name: "rare-earths-prices-chart",
    path: "chart",
    meta: charttexBeRB82x0IvBMp1IzjNFVcyXJWtjwtJohWEHNyyVIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/prices/chart.vue")
  },
  {
    name: "rare-earths-prices",
    path: "",
    meta: indexT4WR7U87NgilL3KdNawsWbjnA4yosLts5oSjEK2ON3IMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/prices/index.vue")
  },
  {
    name: "rare-earths-prices-slug",
    path: ":slug()",
    meta: _91slug_93ZXw6TB6Fu9btkVLSm4zMahCcv_3wP2SDvoYoSetLlqUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/prices/[slug].vue")
  }
]
  },
  {
    name: "announcements",
    path: "/announcements",
    component: () => import("/opt/buildhome/repo/pages/announcements/index.vue")
  },
  {
    name: "cobalt-data-reports",
    path: "/cobalt/data-reports",
    meta: data_45reportss4K40O4facPwT8J6I6KcKLXbTSpCKg9KqfxrI_45RLvAYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/data-reports.vue"),
    children: [
  {
    name: "cobalt-data-reports-forecasts",
    path: "forecasts",
    meta: forecastswWTMCeEeZMqD7_45ROr4fhdkb2hpM8LYCpqhPhrQ6efAwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/data-reports/forecasts.vue")
  },
  {
    name: "cobalt-data-reports-sustainability",
    path: "sustainability",
    meta: sustainabilityxgZJggI7Gsr_oldEtDvR9F9CVAth6iGjmMozyiJEfEIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/data-reports/sustainability.vue")
  },
  {
    name: "cobalt-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsMafhNoNLzAIaTTdXEpBpSpk38u_45NP39Z9R8TMUL_45W6sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "copper-data-reports",
    path: "/copper/data-reports",
    meta: data_45reportsZtrftu_45s1VwG6KE3T_45EdhmaZSLngbHCK_45NRvPSdDxowMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/data-reports.vue"),
    children: [
  {
    name: "copper-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsY2ZE2pWQVzJGhKhpCvNTuUnAxynX9paY6STXUCZKXH8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/data-reports/forecasts.vue")
  },
  {
    name: "copper-data-reports-copper-briefing",
    path: "copper-briefing",
    meta: copper_45briefingo_BfcMqB92NCOddwCLy0UzA4WXHyApkNb0DUhdZbTSEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/data-reports/copper-briefing.vue")
  }
]
  },
  {
    name: "downloadform-slug",
    path: "/downloadform/:slug()",
    component: () => import("/opt/buildhome/repo/pages/downloadform/[slug].vue")
  },
  {
    name: "methodologies",
    path: "/methodologies",
    component: () => import("/opt/buildhome/repo/pages/methodologies/index.vue")
  },
  {
    name: "nickel-data-reports",
    path: "/nickel/data-reports",
    meta: data_45reportsdkxV049C969_ZLDTteN4O4gjbrDIelK2_454p5rjogmucMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/data-reports.vue"),
    children: [
  {
    name: "nickel-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsZHqrEclrJvzMk9Pp8EB4mZIAUWmJFgkY_4553JzhajdHoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/data-reports/forecasts.vue")
  },
  {
    name: "nickel-data-reports-sustainability",
    path: "sustainability",
    meta: sustainabilityU2Q02RBzAGTm2TPdC1CSUIdoeVl10Y7r5LBJMbi4tUQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/data-reports/sustainability.vue")
  },
  {
    name: "nickel-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsl2WZJLg1kRluP_LgLDdeppiF7cuYQGYEEAeAU76UKvYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "silicon-anode",
    path: "/silicon-anode",
    meta: indexwZyhkeIhahNSKbj9Mv2sC2smueJzC_OcAcagsfvyxq0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/index.vue")
  },
  {
    name: "announcements-slug",
    path: "/announcements/:slug()",
    meta: _91slug_93yDEcX0W_45HO_45P_A_w5Dl4yAM1_YIQFnAta22L2EeyjEsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/announcements/[slug].vue")
  },
  {
    name: "cathode-data-reports",
    path: "/cathode/data-reports",
    meta: data_45reports06kz19v3kt4p0B2H0NMCfEWqOXyyUjRpK3Le1hz7WcgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/data-reports.vue"),
    children: [
  {
    name: "cathode-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsy7ILvQmepxTh90vSjydKOfDz12wakD5W24y54oSkI7oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/data-reports/forecasts.vue")
  },
  {
    name: "cathode-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentszPSDrMkqlF6_45PDwG6_CA1A0GCeTJiEB1fzPyAu_45M4BUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/data-reports/price-assessments.vue")
  },
  {
    name: "cathode-data-reports-market-assessments",
    path: "market-assessments",
    meta: market_45assessmentsNBA70qiYi6i8b8xgJq7ija5smxnaEpflZAwTGrIjPRUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/data-reports/market-assessments.vue")
  }
]
  },
  {
    name: "lithium-data-reports",
    path: "/lithium/data-reports",
    meta: data_45reports1c56zMU_Ga1PJyuYOu2dBK12xqN2JkpGcdgi_tQFadIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/data-reports.vue"),
    children: [
  {
    name: "lithium-data-reports-forecasts",
    path: "forecasts",
    meta: forecasts81PBPUNkXuwxgNjH6STLKAH4VxrROISq69bG5a994VgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/data-reports/forecasts.vue")
  },
  {
    name: "lithium-data-reports-sustainability",
    path: "sustainability",
    meta: sustainability_45Cvpto0q1X29YdY8LdDbL1f4tL5C3xTcpmKUaQA83JgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/data-reports/sustainability.vue")
  },
  {
    name: "lithium-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsoQ_tH3hE3ijN35zbk_45BsN1EBajFvDlcZE2adkwPYF4IMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "new-technology",
    path: "/new-technology",
    meta: { ...(indexUVUbiAmmZwjFLCnBTStGBUj8_45nU2H71POr7C2uvRudkMeta || {}), ...{"middleware":["premium-market-guard"]} },
    component: () => import("/opt/buildhome/repo/pages/new-technology/index.vue")
  },
  {
    name: "account-subscriptions",
    path: "/account/subscriptions",
    meta: { ...(subscriptionsef8m95Q1E_45J79LcAd_45RAY3qfixo1CSpfsxjqNkfKKfoMeta || {}), ...{"middleware":["authenticated"]} },
    component: () => import("/opt/buildhome/repo/pages/account/subscriptions.vue")
  },
  {
    name: "anode-market-insights",
    path: "/anode/market-insights",
    meta: market_45insightsGuVDAInSEoIbTR5CcZq7vjv9mzDuccwlXoGaq_Zui1sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/market-insights.vue"),
    children: [
  {
    name: "anode-market-insights-videos",
    path: "videos",
    meta: videosy5MiVRdy2L0bmp2J41MlNQYSqsC55587_MPpizBiApIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/market-insights/videos.vue")
  },
  {
    name: "anode-market-insights-analysis",
    path: "analysis",
    meta: analysis5FFClH0s3_Z9DfXtMj8JRr31rrY7vEU9mjOB__451cFxYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/market-insights/analysis.vue")
  },
  {
    name: "anode-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insights_45JCgfsA4mqrMoEqIBpCOy8kJMR4hjCEFtfuOpNklEU4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "cobalt-sustainability",
    path: "/cobalt/sustainability",
    meta: sustainabilityB3Bm5CXSr7bLQzy_mp_45BITKB7N_455RU8OE43qP9HaFD4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/sustainability.vue"),
    children: [
  {
    name: "cobalt-sustainability-lca",
    path: "lca",
    meta: lcayx_45ZHm5ATA3otzyD52GFUv_45YZrmQ_45PQTHcfQnZ9ibzYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/sustainability/lca.vue")
  },
  {
    name: "cobalt-sustainability-overview",
    path: "overview",
    meta: { ...(overviewOiSHrrphhatmJCe2BWFVh1eCsjJUdfuG1J4L9LPEEEcMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/cobalt/sustainability/overview.vue")
  },
  {
    name: "cobalt-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indexPxo5pxfv8uRaz2YnuUWwtFYrOWSXhrQLbd4KQNp__45hMMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/cobalt/sustainability/sustainability-index.vue")
  },
  {
    name: "cobalt-sustainability-battery-emissions-analyser",
    path: "battery-emissions-analyser",
    meta: battery_45emissions_45analyserRVHcEDRELKMgIfh2VLBrLyA0e5hfosredJ9mT6QhHdYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/sustainability/battery-emissions-analyser.vue")
  }
]
  },
  {
    name: "events-benchmark-week",
    path: "/events/benchmark-week",
    meta: benchmark_45weekFW2BvZPDzRLpZJV_45zZDrj91vjRe8QwUlhrU81GsSZDYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/benchmark-week.vue")
  },
  {
    name: "mineral-pricing-chart",
    path: "/mineral-pricing-chart",
    component: () => import("/opt/buildhome/repo/pages/mineral-pricing-chart.vue")
  },
  {
    name: "new-technology-portal",
    path: "/new-technology/portal",
    meta: portalgX1PHDCPzycm7l7BYZTgbFP18c9puZpB1OjTvTmPickMeta || {},
    component: () => import("/opt/buildhome/repo/pages/new-technology/portal.vue")
  },
  {
    name: "nickel-sustainability",
    path: "/nickel/sustainability",
    meta: sustainability2jCBcwzGLi7J36_rCystW_45uJn8AuXafDEREovIV5mKgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/sustainability.vue"),
    children: [
  {
    name: "nickel-sustainability-lca",
    path: "lca",
    meta: lcaZaBFLidf51Nik5KU1lm_453FA7IkhtqtdO4W0IHi68eD0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/sustainability/lca.vue")
  },
  {
    name: "nickel-sustainability-overview",
    path: "overview",
    meta: { ...(overviewpDONLyavM7wWQwmoi5fqHk34cz83iURPUSqdsrJbz2cMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/nickel/sustainability/overview.vue")
  },
  {
    name: "nickel-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indexWE8xj0imX3ZZJIUpQw9UjmmjU6SCaaj1ouM_wrizCHUMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/nickel/sustainability/sustainability-index.vue")
  },
  {
    name: "nickel-sustainability-battery-emissions-analyser",
    path: "battery-emissions-analyser",
    meta: battery_45emissions_45analysergno0cEzBubXN3m5PAmlCNtJkOVPBPE9xB6A9vmbWTsoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/sustainability/battery-emissions-analyser.vue")
  }
]
  },
  {
    name: "price-dashboard",
    path: "/price-dashboard",
    meta: index39kesrz0VIuwodXEvkWwpVv124mp_X4fvrZB4BgNeGwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/price-dashboard/index.vue")
  },
  {
    name: "cobalt-market-insights",
    path: "/cobalt/market-insights",
    meta: market_45insightsbJEI_45ucptiXRxpSd_Cy_sB5T0VQa14vCGmL6kcyuGm4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/market-insights.vue"),
    children: [
  {
    name: "cobalt-market-insights-videos",
    path: "videos",
    meta: videosfjbFi30_45rY_jXx60zayApKwRibQjf53Rw1saKzWSQSEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/market-insights/videos.vue")
  },
  {
    name: "cobalt-market-insights-analysis",
    path: "analysis",
    meta: analysisu1fmvvcBMbhS6vTsxbg8lghUNehgRZvqWQsKeeko6ggMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/market-insights/analysis.vue")
  },
  {
    name: "cobalt-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightscjYrhSCoDX07vbvyFXAWp0FdMpxSjiQbUCdqKHemmtIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "copper-market-insights",
    path: "/copper/market-insights",
    meta: market_45insightsw1SXVjd1K9YU9hqNXrBx8uQ4tHehmEHMMN8Ki8f8FugMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/market-insights.vue"),
    children: [
  {
    name: "copper-market-insights-videos",
    path: "videos",
    meta: videosnrJQHrkuQe7hWYr9yVKTOR0RUrMZ9ivKalf9UrgTUQoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/market-insights/videos.vue")
  },
  {
    name: "copper-market-insights-analysis",
    path: "analysis",
    meta: analysis5_SOI7W6_6pDje3YGNhXZegE7x8AmH3rqGgNta40wlYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/market-insights/analysis.vue")
  },
  {
    name: "copper-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsDVMy160VIkGeQGSlyRG1_vzpwiF3Kw1E2fFXW55ILxkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "fluorspar-data-reports",
    path: "/fluorspar/data-reports",
    meta: data_45reportsgbaZOc4gjryF3Jb_45qC35u4ccSIdKxv_pOB_45X1lc3ujUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/data-reports.vue"),
    children: [
  {
    name: "fluorspar-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsa9WT5jxj6deKOkW6Ezb_Fmy3CLfTRgcddOaSyw1KGB8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/data-reports/forecasts.vue")
  }
]
  },
  {
    name: "lithium-sustainability",
    path: "/lithium/sustainability",
    meta: sustainabilityRRq6jml3Evu7C9B7lW5dnBywTM1smWIxhO_67TqtIbEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/sustainability.vue"),
    children: [
  {
    name: "lithium-sustainability-lca",
    path: "lca",
    meta: lcaf7X6UACeaKEWCjUXVHYczDwgw_451G1iES2RS_L8AlTVsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/sustainability/lca.vue")
  },
  {
    name: "lithium-sustainability-overview",
    path: "overview",
    meta: { ...(overview8T1RWuRf6net1QW8iUWX0WnZ7iioLX_JNeLJJBx3rw0Meta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/lithium/sustainability/overview.vue")
  },
  {
    name: "lithium-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indexheyROYfwaI3xtQFWRDpPpheqpIkTAik_njvWEAqucM4Meta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/lithium/sustainability/sustainability-index.vue")
  },
  {
    name: "lithium-sustainability-battery-emissions-analyser",
    path: "battery-emissions-analyser",
    meta: battery_45emissions_45analyserxkEwC5fkTnREyQ_QvfOtD3UPc04aVK30Eoit5eL_45268Meta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/sustainability/battery-emissions-analyser.vue")
  }
]
  },
  {
    name: "manganese-data-reports",
    path: "/manganese/data-reports",
    meta: data_45reportstLPdngfcbBB791bXHQbpUAM6P1VbYJ_q4yzgxDCepnUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/data-reports.vue"),
    children: [
  {
    name: "manganese-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsqhz6DZ_5ahlGd42Xj5a0DyDJJi9gd6wRdXGGydNHTDwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/data-reports/forecasts.vue")
  }
]
  },
  {
    name: "natural-graphite",
    path: "/natural-graphite",
    meta: indexKM6uOX9_45GMWZMOKmdmrvqcgwfLORqhSrZwJ5gMM9qpkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/index.vue")
  },
  {
    name: "nickel-market-insights",
    path: "/nickel/market-insights",
    meta: market_45insightsW8daf7d1dbOMjPfxDsbYCDGpworFjvtBVU_gAhTKDbAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/market-insights.vue"),
    children: [
  {
    name: "nickel-market-insights-videos",
    path: "videos",
    meta: videosct7YXBA8E9UNyUyx0giUwiUwnnmNEhFBFmxvm88K1r0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/market-insights/videos.vue")
  },
  {
    name: "nickel-market-insights-analysis",
    path: "analysis",
    meta: analysisV8x2wsWnfOSi9VUF_UUkqogCWlPrUwagyiDeFJ_45Xe0AMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/market-insights/analysis.vue")
  },
  {
    name: "nickel-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsyqJb75QXjoaS718x_45Tp_lDTrNhai_45P2bXbeAO_45MoIEIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "phosphate-data-reports",
    path: "/phosphate/data-reports",
    meta: data_45reportsI54m0M32_45SK3h16wa7wjcPyKmaR7dq5lORcWPtgTFqgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/data-reports.vue"),
    children: [
  {
    name: "phosphate-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsWJXcSRnSJh6FSPydQa6fFBKhs5h_45s72Z4sVqBrnVoPsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/data-reports/forecasts.vue")
  }
]
  },
  {
    name: "preview-_postType-id",
    path: "/preview/_postType/:id()",
    meta: _91id_93XFqkO2v2gzUCjs1czdPR6g8ld8FNSanJH_45P_45cUsImNEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preview/_postType/[id].vue")
  },
  {
    name: "price-spotlight-signup",
    path: "/price-spotlight-signup",
    component: () => import("/opt/buildhome/repo/pages/price-spotlight-signup.vue")
  },
  {
    name: "recycling-data-reports",
    path: "/recycling/data-reports",
    meta: data_45reports8U0FRTokFK4DfOLIG_452PiazaTs0mWOoc9PRwB5zJ55UMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/data-reports.vue"),
    children: [
  {
    name: "recycling-data-reports-forecasts",
    path: "forecasts",
    meta: forecastseYADkzkcfdqJo1n_45Crnq_45UbTp9YNpvwa6_X_45YGBsmlwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/data-reports/forecasts.vue")
  },
  {
    name: "recycling-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessments0dk6nCKYyPX1PHUqi0iWeP9voI8rYzlxkIS7NhO4xUEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: capacity_45databasee7l3ptyb4PBHK49UF0_45vwBoZZBEicrXXeJVw5tkExhkMeta?.name,
    path: "/anode/capacity-database",
    meta: capacity_45databasee7l3ptyb4PBHK49UF0_45vwBoZZBEicrXXeJVw5tkExhkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/capacity-database.vue"),
    children: [
  {
    name: "anode-capacity-database",
    path: "",
    meta: index59bt1rmJZPF5B1AXzbCYXGUlccWvaORTCmQyf8uvAR4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/capacity-database/index.vue")
  },
  {
    name: "anode-capacity-database-sodium-ion-anode",
    path: "sodium-ion-anode",
    meta: sodium_45ion_45anode6HYcK_455cnUsCcufm5p9YCRAO6kUog4fizC__4GxCdRcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/capacity-database/sodium-ion-anode.vue")
  }
]
  },
  {
    name: "cathode-market-insights",
    path: "/cathode/market-insights",
    meta: market_45insightsU5gHCz9ft_nIlfyFVrFhUfmyeBS8gSirt5ow82_6xJ4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/market-insights.vue"),
    children: [
  {
    name: "cathode-market-insights-videos",
    path: "videos",
    meta: videosVoLh_OnGnlWqnnBqN8JN9lfZZ_45Ea5I1XftJUqPWNuM0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/market-insights/videos.vue")
  },
  {
    name: "cathode-market-insights-analysis",
    path: "analysis",
    meta: analysis79bxjcLYh5cEitnEPVYtiQ04193bkSlt9Gi6A6gsnqoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/market-insights/analysis.vue")
  },
  {
    name: "cathode-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsjeY_p42kgvoKDh1Tk5P9ii1RJ1ImiHUF3gX29kwDkg4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "events-africa-day",
    path: "/events/africa-day",
    component: () => import("/opt/buildhome/repo/pages/events/africa-day/index.vue")
  },
  {
    name: "events-evfest2021",
    path: "/events/evfest2021",
    component: () => import("/opt/buildhome/repo/pages/events/evfest2021/index.vue")
  },
  {
    name: "events-nickel-day",
    path: "/events/nickel-day",
    component: () => import("/opt/buildhome/repo/pages/events/nickel-day/index.vue")
  },
  {
    name: "lithium-market-insights",
    path: "/lithium/market-insights",
    meta: market_45insightsM5dXX__45RoyRTwmx_synaTlnFC9iJdRQ1OcjPuFTys8YMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/market-insights.vue"),
    children: [
  {
    name: "lithium-market-insights-videos",
    path: "videos",
    meta: videosF8JU2lzZwewvlRH4KBsuhk7dlXWcNbgArzcdVrpWwjIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/market-insights/videos.vue")
  },
  {
    name: "lithium-market-insights-analysis",
    path: "analysis",
    meta: analysis1a_FKHv0M2pcWOhwC5lzbYZBY0eHP2qRpN814d84iBQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/market-insights/analysis.vue")
  },
  {
    name: "lithium-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsIW0hwN71Mi1H06SnPg8GOL6Cld7e_eLTRieBqe99Ao8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "natural-graphite-slug",
    path: "/natural-graphite/:slug()",
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/[slug].vue")
  },
  {
    name: pricesPqFK_45fp_5oTSpxAe8qj6c98yKd4HTrJ524ET1K5N6P4Meta?.name,
    path: "/natural-graphite/prices",
    meta: pricesPqFK_45fp_5oTSpxAe8qj6c98yKd4HTrJ524ET1K5N6P4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/prices.vue"),
    children: [
  {
    name: "natural-graphite-prices-chart",
    path: "chart",
    meta: charttcUJKh0e_45IU6ZIrIhnGeIADKU8HYidR06on1tbbpLVAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/prices/chart.vue")
  },
  {
    name: "natural-graphite-prices",
    path: "",
    meta: indexyiHprQZOFqpNOOiyJeC3w2NXSv745ik1WVFMuHBu0CkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/prices/index.vue")
  },
  {
    name: "natural-graphite-prices-slug",
    path: ":slug()",
    meta: _91slug_93I_U2Nt3gflNitMu9eI9Kql7pF5bKHQX42TevxWRWMUYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/prices/[slug].vue")
  },
  {
    name: "natural-graphite-prices-price-customisation-tool",
    path: "price-customisation-tool",
    meta: price_45customisation_45toolKj1TXNon5EeyEnhM_45bQRH5TtD_2W9n6cwbF1EZQkOPEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/prices/price-customisation-tool.vue")
  }
]
  },
  {
    name: "price-assessments",
    path: "/price-assessments",
    meta: { ...(indexbFJbU_45uU80OU1a3ygzJMjogRXw4o_WfLztOXlXeLBJEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/price-assessments/index.vue")
  },
  {
    name: "events-ev-festival",
    path: "/events/ev-festival",
    component: () => import("/opt/buildhome/repo/pages/events/ev-festival/index.vue")
  },
  {
    name: "rare-earths-data-reports",
    path: "/rare-earths/data-reports",
    meta: data_45reportsNEZHWzcOS_gek61NkZAyrUjqaEW27iFykqQc6RnDILMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/data-reports.vue"),
    children: [
  {
    name: "rare-earths-data-reports-forecasts",
    path: "forecasts",
    meta: forecasts2F3r_45x7PZfr4UlpYbQvHJ33qnzThmxsW7CPDlBl5TyUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/data-reports/forecasts.vue")
  },
  {
    name: "rare-earths-data-reports-sustainability",
    path: "sustainability",
    meta: sustainabilityDxjSzjD10HbEV9EidxDExoIe4wZrbT1WlLSNMNxpECoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/data-reports/sustainability.vue")
  },
  {
    name: "rare-earths-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsC3_45XGH3WzlJR_45ilbNxGyC5Qd0t3fd2scvM0JQF9XOv0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "synthetic-graphite",
    path: "/synthetic-graphite",
    meta: indexSrflw_45RKtNDaCfGXveUmgg8K5vQq_9oSJ4p2rbcBwfUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/index.vue")
  },
  {
    name: "battery-gigafactory",
    path: "/battery-gigafactory",
    meta: { ...(indexg_VlOVtVubGPiI0xh_hA_45TvAQYh9BKrLhlPit18edXEMeta || {}), ...{"middleware":["premium-market-guard"]} },
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/index.vue")
  },
  {
    name: capacity_45databaseFSnHeDo1aAHeEh_459j1JnM7LaMVkISGj8wffjzQlAVdgMeta?.name,
    path: "/cathode/capacity-database",
    meta: capacity_45databaseFSnHeDo1aAHeEh_459j1JnM7LaMVkISGj8wffjzQlAVdgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/capacity-database.vue"),
    children: [
  {
    name: "cathode-capacity-database",
    path: "",
    meta: indexlZMtPlsjQO4dc9q6Ym_CuZsWREDDaO_45bKCvfOUNNzxwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/capacity-database/index.vue")
  },
  {
    name: "cathode-capacity-database-precursor",
    path: "precursor",
    meta: precursorQcp_x83GfokouyURfYws_fnQLNKRZK_go9DovuMLkd4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/capacity-database/precursor.vue")
  },
  {
    name: "cathode-capacity-database-sodium-ion-cathode",
    path: "sodium-ion-cathode",
    meta: sodium_45ion_45cathode8f_gXVdMQWt_45_45ekL_vWQO_nZzs5g_45jFBWgrEnjNLfr0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/capacity-database/sodium-ion-cathode.vue")
  }
]
  },
  {
    name: "events-cathodes2017",
    path: "/events/cathodes2017",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes2017/index.vue")
  },
  {
    name: "events-graphite2016-hosts",
    path: "/events/graphite2016/hosts",
    component: () => import("/opt/buildhome/repo/pages/events/graphite2016/hosts.vue")
  },
  {
    name: "events-graphite2016",
    path: "/events/graphite2016",
    component: () => import("/opt/buildhome/repo/pages/events/graphite2016/index.vue")
  },
  {
    name: "events-graphite2017-hosts",
    path: "/events/graphite2017/hosts",
    component: () => import("/opt/buildhome/repo/pages/events/graphite2017/hosts.vue")
  },
  {
    name: "events-graphite2017",
    path: "/events/graphite2017",
    component: () => import("/opt/buildhome/repo/pages/events/graphite2017/index.vue")
  },
  {
    name: "fluorspar-market-insights",
    path: "/fluorspar/market-insights",
    meta: market_45insightsb9dsM_TdtGGMsKBbxHj74YftTzrQmenZmUZ6InEHCNQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/market-insights.vue"),
    children: [
  {
    name: "fluorspar-market-insights-videos",
    path: "videos",
    meta: videoskqyxF7jy9PnZ1jDEqmteQk3hIMh4jMejeUz6SqvZjo0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/market-insights/videos.vue")
  },
  {
    name: "fluorspar-market-insights-analysis",
    path: "analysis",
    meta: analysisbUlncyfMIlJpLAVvUUVvqehd005v0PgAq38_45HxwNeSIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/market-insights/analysis.vue")
  },
  {
    name: "fluorspar-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsy_oQxWsmyAiuOBAoyw4g1KEpIs_PJJ7qjOc5jVMnGjYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "manganese-market-insights",
    path: "/manganese/market-insights",
    meta: market_45insights_gh6CFo9yga2a9KKiHjmZyGUcLfXJUxlG_LMAVFC7w0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/market-insights.vue"),
    children: [
  {
    name: "manganese-market-insights-videos",
    path: "videos",
    meta: videos1PrpHdQzU6pnJ9mmu7kUDOl840655uEAh_45_PY_45v8BUUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/market-insights/videos.vue")
  },
  {
    name: "manganese-market-insights-analysis",
    path: "analysis",
    meta: analysis1KicjvkWw8JC3GGsw_Dhqj9UPe29In9FmNQ0qweCFe0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/market-insights/analysis.vue")
  },
  {
    name: "manganese-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightss3V52jfdh0dDsdyinmOo5sAk_45gJHHs2r7xSRriYMyg0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "phosphate-market-insights",
    path: "/phosphate/market-insights",
    meta: market_45insightsw3spT2DD0X8iDJ9XMUlCW9a7vPewU4fBCPr1XJLevlwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/market-insights.vue"),
    children: [
  {
    name: "phosphate-market-insights-videos",
    path: "videos",
    meta: videos1qVEKZGjHk_AJmawVd0oeFfZ1KFRSzeCSyi3Rjm_45xXsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/market-insights/videos.vue")
  },
  {
    name: "phosphate-market-insights-analysis",
    path: "analysis",
    meta: analysisnog_45e13M66QjzZZCWS8uYSXbBabyg5KY7GIX1WEzGDEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/market-insights/analysis.vue")
  },
  {
    name: "phosphate-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightszCDr_45UCacJc6Mzb_45Rb1x5nqYvzy0r9YoQPWUe3051isMeta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "recycling-market-insights",
    path: "/recycling/market-insights",
    meta: market_45insights8PI2RbciLA1HlUdv79ciCwpF_pe1VGjfc04t3IVsguMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/market-insights.vue"),
    children: [
  {
    name: "recycling-market-insights-videos",
    path: "videos",
    meta: videosUD9lI68mx_45lPTnTtGeXk_45WBE2jMChlHLIc7ZcTuFTYUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/market-insights/videos.vue")
  },
  {
    name: "recycling-market-insights-analysis",
    path: "analysis",
    meta: analysisske8hu_45i9MzfTcJIBOq_45Hi3ZLr4ClN0ASh7DC_45EBZTIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/market-insights/analysis.vue")
  },
  {
    name: "recycling-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insights9EQQ4qc2i3C992dsbiDbTcke7KTB3rQKOlfqQblW17wMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "synthetic-graphite-slug",
    path: "/synthetic-graphite/:slug()",
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/[slug].vue")
  },
  {
    name: priceslFCozIzKvzh7HqTQE0hsdOYkBWnrHAvbTg7IecnOoEcMeta?.name,
    path: "/synthetic-graphite/prices",
    meta: priceslFCozIzKvzh7HqTQE0hsdOYkBWnrHAvbTg7IecnOoEcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/prices.vue"),
    children: [
  {
    name: "synthetic-graphite-prices-chart",
    path: "chart",
    meta: chartphzVXtDbi_5ZcR_45CGbmUkFqLJ2D2zODv1xZV3StLKj8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/prices/chart.vue")
  },
  {
    name: "synthetic-graphite-prices",
    path: "",
    meta: index_45JXSe5i9wiyNW_45v7xMDNN2FRY0nOzlAYvEq8gsneMSMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/prices/index.vue")
  },
  {
    name: "synthetic-graphite-prices-slug",
    path: ":slug()",
    meta: _91slug_93fTlU5OeCdw6Aj4Bph5fuN2_45UwfqP1CAmrbvTJpuQqEoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/prices/[slug].vue")
  },
  {
    name: "synthetic-graphite-prices-price-customisation-tool",
    path: "price-customisation-tool",
    meta: price_45customisation_45toolbidZOjWILLSf9O9xAW9fB0sEBH2IFSR_9N8INSUz1ckMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/prices/price-customisation-tool.vue")
  }
]
  },
  {
    name: "battery-emissions-analyser",
    path: "/battery-emissions-analyser",
    meta: battery_45emissions_45analyserZ_45AxFlxXOwgBcNfHgDJE8jFVMs1jOv8O6CSU8lZWcSMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-emissions-analyser.vue")
  },
  {
    name: "battery-gigafactory-portal",
    path: "/battery-gigafactory/portal",
    meta: portalLnGbyVnCR5f2OGb2fH7n1GNq2UTqDFNdR0PG3tf78BoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/portal.vue")
  },
  {
    name: "events-cathodes-2018",
    path: "/events/cathodes-2018",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes-2018/index.vue")
  },
  {
    name: "events-cathodes-2019",
    path: "/events/cathodes-2019",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes-2019/index.vue")
  },
  {
    name: "events-cathodes2017-agenda",
    path: "/events/cathodes2017/agenda",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes2017/agenda.vue")
  },
  {
    name: "events-graphite2016-agenda",
    path: "/events/graphite2016/agenda",
    component: () => import("/opt/buildhome/repo/pages/events/graphite2016/agenda.vue")
  },
  {
    name: "events-graphite2017-agenda",
    path: "/events/graphite2017/agenda",
    component: () => import("/opt/buildhome/repo/pages/events/graphite2017/agenda.vue")
  },
  {
    name: "events-worldtour2017",
    path: "/events/worldtour2017",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/index.vue")
  },
  {
    name: "events-worldtour2017-perth",
    path: "/events/worldtour2017/perth",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/perth.vue")
  },
  {
    name: "events-worldtour2017-seoul",
    path: "/events/worldtour2017/seoul",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/seoul.vue")
  },
  {
    name: "events-worldtour2017-tokyo",
    path: "/events/worldtour2017/tokyo",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/tokyo.vue")
  },
  {
    name: "lithium-ion-battery-prices",
    path: "/lithium-ion-battery-prices",
    component: () => import("/opt/buildhome/repo/pages/lithium-ion-battery-prices.vue")
  },
  {
    name: "rare-earths-sustainability",
    path: "/rare-earths/sustainability",
    meta: sustainability2HKR2AFr0MctOn9CV7vPIu64FRHKsDfB2M6CALsw2qgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/sustainability.vue"),
    children: [
  {
    name: "rare-earths-sustainability-lca",
    path: "lca",
    meta: lcaxoFOsuSwKQb8tvTv3nSTqveEln_o_45XRGORB53eTbWPAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/sustainability/lca.vue")
  },
  {
    name: "rare-earths-sustainability-overview",
    path: "overview",
    meta: { ...(overviewseruQu25iPLw__ti_WGPGSEtaDBI3DtESohmBWG3OuwMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/rare-earths/sustainability/overview.vue")
  },
  {
    name: "rare-earths-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indextXXGfoXEGn3iYjzp2POvI_3yJX0KMxp2lZtYB_45e9_BUMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/rare-earths/sustainability/sustainability-index.vue")
  }
]
  },
  {
    name: "silicon-anode-data-reports",
    path: "/silicon-anode/data-reports",
    meta: data_45reportsoy_45mVMUK_459kR88u5jCE44pYOVS8dpolYgdM4bFXvTCQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/data-reports.vue"),
    children: [
  {
    name: "silicon-anode-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsM2Exh7WIHeUe14hSTbD7WxwYx3RBA7DCMq6RYdzdUkcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/data-reports/forecasts.vue")
  }
]
  },
  {
    name: "events-cathodes-2018-agenda",
    path: "/events/cathodes-2018/agenda",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes-2018/agenda.vue")
  },
  {
    name: "events-cathodes-2019-agenda",
    path: "/events/cathodes-2019/agenda",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes-2019/agenda.vue")
  },
  {
    name: "events-worldtour-2015",
    path: "/events/worldtour-2015",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2015/index.vue")
  },
  {
    name: "events-worldtour-2015-tokyo",
    path: "/events/worldtour-2015/tokyo",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2015/tokyo.vue")
  },
  {
    name: "events-worldtour-2016",
    path: "/events/worldtour-2016",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/index.vue")
  },
  {
    name: "events-worldtour-2016-tokyo",
    path: "/events/worldtour-2016/tokyo",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/tokyo.vue")
  },
  {
    name: "events-worldtour2017-london",
    path: "/events/worldtour2017/london",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/london.vue")
  },
  {
    name: "events-worldtour2017-sydney",
    path: "/events/worldtour2017/sydney",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/sydney.vue")
  },
  {
    name: "events-worldtour2017-zurich",
    path: "/events/worldtour2017/zurich",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/zurich.vue")
  },
  {
    name: "new-technology-data-reports",
    path: "/new-technology/data-reports",
    component: () => import("/opt/buildhome/repo/pages/new-technology/data-reports.vue"),
    children: [
  {
    name: "new-technology-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsDaiL_2OV881qCf22HIymn_45wT9AmeHaWlXC4MmJv2d_cMeta || {},
    component: () => import("/opt/buildhome/repo/pages/new-technology/data-reports/forecasts.vue")
  }
]
  },
  {
    name: "rare-earths-market-insights",
    path: "/rare-earths/market-insights",
    meta: market_45insightsspHqgPkgSAg4L7Msp0ehClMKAzoudmTrLqcyEn_45ttgcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/market-insights.vue"),
    children: [
  {
    name: "rare-earths-market-insights-videos",
    path: "videos",
    meta: videos9C950AHA8vq8KkjSEgBZ63RLSMcSv0wjIpdfkKlxnecMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/market-insights/videos.vue")
  },
  {
    name: "rare-earths-market-insights-analysis",
    path: "analysis",
    meta: analysisRkzKQgzK_iTGniALJOXkL2NH2juv_arQ80gUEjzj9tAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/market-insights/analysis.vue")
  },
  {
    name: "rare-earths-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsIeRbaUqxZBWpLP09IveEoA6OINVYFInWRb2wgJukTzsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: black_45mass_45prices4pzz_REFyAbbL_3kOWyJaY6t6IEYzCJ2Wkk_45OcgH3BoMeta?.name,
    path: "/recycling/black-mass-prices",
    meta: black_45mass_45prices4pzz_REFyAbbL_3kOWyJaY6t6IEYzCJ2Wkk_45OcgH3BoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/black-mass-prices.vue"),
    children: [
  {
    name: "recycling-black-mass-prices-chart",
    path: "chart",
    meta: chartaTXhIT6_hAQmVmAUEuTvACXgXm2hY3FyC5nVvvQSLcUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/black-mass-prices/chart.vue")
  },
  {
    name: "recycling-black-mass-prices",
    path: "",
    meta: index6PNkphKUs0xAC5idz0vkTJDVQZp_pQ27na3iBzH244AMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/black-mass-prices/index.vue")
  },
  {
    name: "recycling-black-mass-prices-slug",
    path: ":slug()",
    meta: _91slug_93PO3QpZcwMEyVk62yvFFzeWLC_YGd_F1w3sngwH1CM7sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/black-mass-prices/[slug].vue")
  }
]
  },
  {
    name: "events-cathodes2017-location",
    path: "/events/cathodes2017/location",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes2017/location.vue")
  },
  {
    name: "events-cathodes2017-sponsors",
    path: "/events/cathodes2017/sponsors",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes2017/sponsors.vue")
  },
  {
    name: "events-graphite2016-location",
    path: "/events/graphite2016/location",
    component: () => import("/opt/buildhome/repo/pages/events/graphite2016/location.vue")
  },
  {
    name: "events-graphite2016-sponsors",
    path: "/events/graphite2016/sponsors",
    component: () => import("/opt/buildhome/repo/pages/events/graphite2016/sponsors.vue")
  },
  {
    name: "events-graphite2017-location",
    path: "/events/graphite2017/location",
    component: () => import("/opt/buildhome/repo/pages/events/graphite2017/location.vue")
  },
  {
    name: "events-graphite2017-sponsors",
    path: "/events/graphite2017/sponsors",
    component: () => import("/opt/buildhome/repo/pages/events/graphite2017/sponsors.vue")
  },
  {
    name: "events-world-tour-2018",
    path: "/events/world-tour-2018",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/index.vue")
  },
  {
    name: "events-world-tour-2018-perth",
    path: "/events/world-tour-2018/perth",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/perth.vue")
  },
  {
    name: "events-world-tour-2018-seoul",
    path: "/events/world-tour-2018/seoul",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/seoul.vue")
  },
  {
    name: "events-world-tour-2018-tokyo",
    path: "/events/world-tour-2018/tokyo",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/tokyo.vue")
  },
  {
    name: "events-world-tour-2019",
    path: "/events/world-tour-2019",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/index.vue")
  },
  {
    name: "events-world-tour-2019-perth",
    path: "/events/world-tour-2019/perth",
    meta: perth9peQjfQy9S20muI_45MTJYrV_xkW_hBTaSYPGnaTlpYksMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/perth.vue")
  },
  {
    name: "events-world-tour-2019-seoul",
    path: "/events/world-tour-2019/seoul",
    meta: seoul_45VKzkXjpeo5MBAUPQArEECTpB6ArCR8GS81GEtnMutgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/seoul.vue")
  },
  {
    name: "events-world-tour-2019-tokyo",
    path: "/events/world-tour-2019/tokyo",
    meta: tokyoVgypQqtgXC_4b6_45d9BloHbj7_45D8Ms7zXcCVx6Vq93K4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/tokyo.vue")
  },
  {
    name: "events-world-tour-2020",
    path: "/events/world-tour-2020",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2020/index.vue")
  },
  {
    name: "events-world-tour-2022",
    path: "/events/world-tour-2022",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2022/index.vue")
  },
  {
    name: "events-worldtour-2015-canada",
    path: "/events/worldtour-2015/canada",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2015/canada.vue")
  },
  {
    name: "events-worldtour-2015-london",
    path: "/events/worldtour-2015/london",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2015/london.vue")
  },
  {
    name: "events-worldtour-2015-sydney",
    path: "/events/worldtour-2015/sydney",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2015/sydney.vue")
  },
  {
    name: "events-worldtour-2016-canada",
    path: "/events/worldtour-2016/canada",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/canada.vue")
  },
  {
    name: "events-worldtour-2016-london",
    path: "/events/worldtour-2016/london",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/london.vue")
  },
  {
    name: "events-worldtour-2016-sydney",
    path: "/events/worldtour-2016/sydney",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/sydney.vue")
  },
  {
    name: "events-worldtour2017-beijing",
    path: "/events/worldtour2017/beijing",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/beijing.vue")
  },
  {
    name: "events-worldtour2017-germany",
    path: "/events/worldtour2017/germany",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/germany.vue")
  },
  {
    name: "events-worldtour2017-newyork",
    path: "/events/worldtour2017/newyork",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/newyork.vue")
  },
  {
    name: "events-worldtour2017-toronto",
    path: "/events/worldtour2017/toronto",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/toronto.vue")
  },
  {
    name: "events-battery-day-2020",
    path: "/events/battery-day-2020",
    component: () => import("/opt/buildhome/repo/pages/events/battery-day-2020/index.vue")
  },
  {
    name: "events-cathodes-2018-location",
    path: "/events/cathodes-2018/location",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes-2018/location.vue")
  },
  {
    name: "events-cathodes-2018-sponsors",
    path: "/events/cathodes-2018/sponsors",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes-2018/sponsors.vue")
  },
  {
    name: "events-cathodes-2019-location",
    path: "/events/cathodes-2019/location",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes-2019/location.vue")
  },
  {
    name: "events-cathodes-2019-sponsors",
    path: "/events/cathodes-2019/sponsors",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes-2019/sponsors.vue")
  },
  {
    name: "events-world-tour-2018-london",
    path: "/events/world-tour-2018/london",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/london.vue")
  },
  {
    name: "events-world-tour-2018-sydney",
    path: "/events/world-tour-2018/sydney",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/sydney.vue")
  },
  {
    name: "events-world-tour-2019-london",
    path: "/events/world-tour-2019/london",
    meta: londonbXTSYu7Ad_45pcFnTEnXcOeCr6BVMiYhy505us_BF66N8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/london.vue")
  },
  {
    name: "events-world-tour-2019-sydney",
    path: "/events/world-tour-2019/sydney",
    meta: sydneyXK4t2demFddVy_45RhoEVUzN5RvPaRGwE0EZuWJb4_BLUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/sydney.vue")
  },
  {
    name: "events-world-tour-2022-slug",
    path: "/events/world-tour-2022/:slug()",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2022/[slug].vue")
  },
  {
    name: "events-worldtour-2015-newyork",
    path: "/events/worldtour-2015/newyork",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2015/newyork.vue")
  },
  {
    name: "events-worldtour-2015-toronto",
    path: "/events/worldtour-2015/toronto",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2015/toronto.vue")
  },
  {
    name: "events-worldtour-2016-germany",
    path: "/events/worldtour-2016/germany",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/germany.vue")
  },
  {
    name: "events-worldtour-2016-newyork",
    path: "/events/worldtour-2016/newyork",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/newyork.vue")
  },
  {
    name: "events-worldtour-2016-silicon",
    path: "/events/worldtour-2016/silicon",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/silicon.vue")
  },
  {
    name: "events-worldtour-2016-toronto",
    path: "/events/worldtour-2016/toronto",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/toronto.vue")
  },
  {
    name: "events-worldtour2017-hongkong",
    path: "/events/worldtour2017/hongkong",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/hongkong.vue")
  },
  {
    name: "natural-graphite-data-reports",
    path: "/natural-graphite/data-reports",
    meta: data_45reportsct7S3OMqT8zEYlfsqMtNMCkdaWi9IGLKzpoBpo1HxvUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/data-reports.vue"),
    children: [
  {
    name: "natural-graphite-data-reports-forecasts",
    path: "forecasts",
    meta: forecasts_SPAejp_sbgY1blBL15_4533YM98RYIUUUk_45ZUAHicatgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/data-reports/forecasts.vue")
  },
  {
    name: "natural-graphite-data-reports-sustainability",
    path: "sustainability",
    meta: sustainabilityuvcVYKUbN7UY4ehckJs4tMq_t_idpFnI7cHQ_4579X2_450Meta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/data-reports/sustainability.vue")
  },
  {
    name: "natural-graphite-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentshBFZqzulBQxxANaNYDbac5SZtlaJEkZ4Gomh9q4Dh9oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "price-dashboard-chart-builder",
    path: "/price-dashboard/chart-builder",
    meta: chart_45builderlr6t8ngqoqfqxbU9_45N_JoNIGuRJEtxe2Rkb7ZGTJH70Meta || {},
    component: () => import("/opt/buildhome/repo/pages/price-dashboard/chart-builder.vue")
  },
  {
    name: "silicon-anode-market-insights",
    path: "/silicon-anode/market-insights",
    meta: market_45insightsrcF_0Wg1WNxiJvWTztOLtva9g7fdswL86IwuUxpclkUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/market-insights.vue"),
    children: [
  {
    name: "silicon-anode-market-insights-videos",
    path: "videos",
    meta: videosTdoIRuhAzEEndBQvQWKD6V3KB0iuu_4y1dWO4HpZUFoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/market-insights/videos.vue")
  },
  {
    name: "silicon-anode-market-insights-analysis",
    path: "analysis",
    meta: analysisZmBLceel3q13JNUtuvWS23Kukt9L54_45csgtyxWqNvcYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/market-insights/analysis.vue")
  },
  {
    name: "silicon-anode-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsyMzDn1yaPcKFGI_WteHLz_45O9rhf25nMAl3d3DTxsbQ4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "events-world-tour-2018-chicago",
    path: "/events/world-tour-2018/chicago",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/chicago.vue")
  },
  {
    name: "events-world-tour-2018-germany",
    path: "/events/world-tour-2018/germany",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/germany.vue")
  },
  {
    name: "events-world-tour-2018-toronto",
    path: "/events/world-tour-2018/toronto",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/toronto.vue")
  },
  {
    name: "events-world-tour-2019-chicago",
    path: "/events/world-tour-2019/chicago",
    meta: chicagoyv25oBUrZQAjjx3Vho_45ZtZNQJ2LUqa_I_yec5J_45dGJ8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/chicago.vue")
  },
  {
    name: "events-world-tour-2019-germany",
    path: "/events/world-tour-2019/germany",
    meta: germanyz3bob9FwRgVFS3nMdEwjopfXzv6qywXX96sl4jaDEXsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/germany.vue")
  },
  {
    name: "events-world-tour-2019-toronto",
    path: "/events/world-tour-2019/toronto",
    meta: torontoUGjWnxrFmDMbfbWuD0CYk0NsbuXOFzoFJlv0f2QR2SIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/toronto.vue")
  },
  {
    name: "events-world-tour-online",
    path: "/events/world-tour-online",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-online/index.vue")
  },
  {
    name: "events-worldtour-2015-hongkong",
    path: "/events/worldtour-2015/hongkong",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2015/hongkong.vue")
  },
  {
    name: "events-worldtour-2016-hongkong",
    path: "/events/worldtour-2016/hongkong",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/hongkong.vue")
  },
  {
    name: "events-worldtour2017-melbourne",
    path: "/events/worldtour2017/melbourne",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/melbourne.vue")
  },
  {
    name: "events-worldtour2017-vancouver",
    path: "/events/worldtour2017/vancouver",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/vancouver.vue")
  },
  {
    name: "new-technology-market-insights",
    path: "/new-technology/market-insights",
    component: () => import("/opt/buildhome/repo/pages/new-technology/market-insights.vue"),
    children: [
  {
    name: "new-technology-market-insights-videos",
    path: "videos",
    meta: videoscK9da_9Rv1JIraHrzZA8ghJvJGTMq31OCg_Dae7FUB4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/new-technology/market-insights/videos.vue")
  },
  {
    name: "new-technology-market-insights-analysis",
    path: "analysis",
    meta: analysis8_my2XChk3PRA2DFDPU25MVWnlyfHcfS26py0ZFGvNkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/new-technology/market-insights/analysis.vue")
  },
  {
    name: "new-technology-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsiViy2OdOhzByJJAKXJTFIkn4__SN_453OZZJR11vJRkXsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/new-technology/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "price-dashboard-watchlist-id",
    path: "/price-dashboard/watchlist/:id()",
    meta: { ...(_91id_932ttV3F0SuVBw0tXLyLFOtjM6sg6OatpxohoiTnci_459oMeta || {}), ...{"middleware":["price-dashboard"]} },
    component: () => import("/opt/buildhome/repo/pages/price-dashboard/watchlist/[id].vue")
  },
  {
    name: "events-cathodes-2019-field-trip",
    path: "/events/cathodes-2019/field-trip",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes-2019/field-trip.vue")
  },
  {
    name: "events-world-tour-2018-new-york",
    path: "/events/world-tour-2018/new-york",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/new-york.vue")
  },
  {
    name: "events-world-tour-2019-adelaide",
    path: "/events/world-tour-2019/adelaide",
    meta: adelaidepwJC_45T1tyNVLW958wj_453dKdUgFHVLqnIQTF8SYrFdcwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/adelaide.vue")
  },
  {
    name: "events-world-tour-2019-new-york",
    path: "/events/world-tour-2019/new-york",
    meta: new_45yorkDQOKUeOLCudAsC5pXqb03SKHmowyEHaFH5BVTXCjxUEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/new-york.vue")
  },
  {
    name: "events-worldtour-2015-melbourne",
    path: "/events/worldtour-2015/melbourne",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2015/melbourne.vue")
  },
  {
    name: "events-worldtour-2016-melbourne",
    path: "/events/worldtour-2016/melbourne",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/melbourne.vue")
  },
  {
    name: "natural-graphite-sustainability",
    path: "/natural-graphite/sustainability",
    meta: sustainabilityGGHxoVd9mBBqCtPJnKLN7N6vecP_SPO8Paoh97L9_ZUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/sustainability.vue"),
    children: [
  {
    name: "natural-graphite-sustainability-lca",
    path: "lca",
    meta: lca50Mu2Us9_tmSXZljHPCgg_45BjA9WEbwvncEJCiGR4lVsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/sustainability/lca.vue")
  },
  {
    name: "natural-graphite-sustainability-overview",
    path: "overview",
    meta: { ...(overviewcC3cqKqf8KKcWNYve6_45HkSlffqxhMm_45BczOEaJ_45IdBcMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/sustainability/overview.vue")
  },
  {
    name: "natural-graphite-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indexneUZ52JNw0BJFtrEL_45_09xeBBVporaptGY2Nw3sXtOUMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/sustainability/sustainability-index.vue")
  },
  {
    name: "natural-graphite-sustainability-battery-emissions-analyser",
    path: "battery-emissions-analyser",
    meta: battery_45emissions_45analyserCeC_R_604avO_ZNKVCEFYFAZEkJ95uF3TRloiMbGkEoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/sustainability/battery-emissions-analyser.vue")
  }
]
  },
  {
    name: "price-dashboard-watchlist",
    path: "/price-dashboard/watchlist",
    meta: { ...(index1WsTlVhvhQXMTPMtibJk3sjemyv9V0NKZyWp60MzQjYMeta || {}), ...{"middleware":"price-dashboard"} },
    component: () => import("/opt/buildhome/repo/pages/price-dashboard/watchlist/index.vue")
  },
  {
    name: "synthetic-graphite-data-reports",
    path: "/synthetic-graphite/data-reports",
    meta: data_45reportsYcFdpkhIbSlj7hLqpSADre_45QBo101OsUQisv2cOnk5IMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/data-reports.vue"),
    children: [
  {
    name: "synthetic-graphite-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsQm8J_45GWfyJ7deQCfAUrCYzf5LMse25QvHneyLoDvwoMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/data-reports/forecasts.vue")
  },
  {
    name: "synthetic-graphite-data-reports-sustainability",
    path: "sustainability",
    meta: sustainabilityo1ipOGWYHkIxbq13M1YqwqjAYRSWQ7GMGu9ONtxN71oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/data-reports/sustainability.vue")
  },
  {
    name: "synthetic-graphite-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsVOv21o3fPLQb4GrRovYMBKr49WQs6JJ5VxAv0uLnTCAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "battery-gigafactory-data-reports",
    path: "/battery-gigafactory/data-reports",
    meta: data_45reports_45c9ylmhlcPihaO_45UN6rUaOfrxyNqFsLkBVeAnKWJD_45wMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/data-reports.vue"),
    children: [
  {
    name: "battery-gigafactory-data-reports-forecasts",
    path: "forecasts",
    meta: forecasts69Zg4JpnM7U13Ja3EF2xvczl8ybgDxzmqF_45xj2ZBT1sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/data-reports/forecasts.vue")
  },
  {
    name: "battery-gigafactory-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsc4DuL6Qtq9BG9DQCvAtedEoo_45IsZeClGR9o4XPV1acIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/data-reports/price-assessments.vue")
  },
  {
    name: "battery-gigafactory-data-reports-market-assessments",
    path: "market-assessments",
    meta: market_45assessmentsTptWk9rthyQqHXf7fNV6u8m_45I14vkrvEM4syvhqVLJ8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/data-reports/market-assessments.vue")
  }
]
  },
  {
    name: "events-cathodes-2018-site-visits",
    path: "/events/cathodes-2018/site-visits",
    component: () => import("/opt/buildhome/repo/pages/events/cathodes-2018/site-visits.vue")
  },
  {
    name: "events-world-tour-2018-hong-kong",
    path: "/events/world-tour-2018/hong-kong",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/hong-kong.vue")
  },
  {
    name: "events-world-tour-2018-melbourne",
    path: "/events/world-tour-2018/melbourne",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/melbourne.vue")
  },
  {
    name: "events-world-tour-2018-vancouver",
    path: "/events/world-tour-2018/vancouver",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/vancouver.vue")
  },
  {
    name: "events-world-tour-2019-cape-town",
    path: "/events/world-tour-2019/cape-town",
    meta: cape_45townwVzttEpFJNVzTZ3lvgcS2nj712ox2e6Hlelx4XsMf7YMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/cape-town.vue")
  },
  {
    name: "events-world-tour-2019-hong-kong",
    path: "/events/world-tour-2019/hong-kong",
    meta: hong_45konguhSRQ5FErWpq6QRmKsjAg8lFBIf6ugNbtcgShZy6ZXwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/hong-kong.vue")
  },
  {
    name: "events-world-tour-2019-melbourne",
    path: "/events/world-tour-2019/melbourne",
    meta: melbourneEepzrJ9gTxCKPHLSjSLxHS6x59O8muEz7HNnp0_5bvYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/melbourne.vue")
  },
  {
    name: "events-world-tour-2019-vancouver",
    path: "/events/world-tour-2019/vancouver",
    meta: vancouverK_Rdm1YeU45RkKCeV7xjhIxm2aHhBrxLYTezztQQaEQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/vancouver.vue")
  },
  {
    name: "events-worldtour-2016-washington",
    path: "/events/worldtour-2016/washington",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour-2016/washington.vue")
  },
  {
    name: "lifetime-achievement-award",
    path: "/lifetime-achievement-award",
    component: () => import("/opt/buildhome/repo/pages/lifetime-achievement-award/index.vue")
  },
  {
    name: "natural-graphite-market-insights",
    path: "/natural-graphite/market-insights",
    meta: market_45insightsHrfjydOf4OFO5Paxo7ZdBXmqTKdzdddYI3IxouRBmzEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/market-insights.vue"),
    children: [
  {
    name: "natural-graphite-market-insights-videos",
    path: "videos",
    meta: videos8QQy85x165BbCeXcjr_4FYnS0DMZjbWeVzMSFuChhvYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/market-insights/videos.vue")
  },
  {
    name: "natural-graphite-market-insights-analysis",
    path: "analysis",
    meta: analysisD_2hag6U4b16g_4J6zS2fOioEWxDIRmABco91ldFCA8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/market-insights/analysis.vue")
  },
  {
    name: "natural-graphite-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insights3pn3HKWcEYwzKeGauhpfFZqls6Tz7Wh3p7l8ZImrhXQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "events-world-tour-2019-new-york-2",
    path: "/events/world-tour-2019/new-york-2",
    meta: new_45york_452CpFHyPAxvmz_MGW5wZ_zlPhYz2DjNAG7ZSm19JpMnf8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/new-york-2.vue")
  },
  {
    name: "events-worldtour2017-washingtondc",
    path: "/events/worldtour2017/washingtondc",
    component: () => import("/opt/buildhome/repo/pages/events/worldtour2017/washingtondc.vue")
  },
  {
    name: "synthetic-graphite-sustainability",
    path: "/synthetic-graphite/sustainability",
    meta: sustainabilityguROWt1ceEKfHogtidtK22y6_45eZY0WJ_IETmEKd7umQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/sustainability.vue"),
    children: [
  {
    name: "synthetic-graphite-sustainability-lca",
    path: "lca",
    meta: lcaWQ_XjzbRRtMQwsQF0LHMeae9bZ3v_45fALPuLApiQCwDMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/sustainability/lca.vue")
  },
  {
    name: "synthetic-graphite-sustainability-overview",
    path: "overview",
    meta: { ...(overview97z0CWhh8uCHPkjuvl2_ybGPIyikIOwXw6CIwzlrJSMMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/sustainability/overview.vue")
  },
  {
    name: "synthetic-graphite-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indexe7ePvFcIuRqxtG_TffLK5P3H8_456uFjk3iDHIvOFly6QMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/sustainability/sustainability-index.vue")
  },
  {
    name: "synthetic-graphite-sustainability-battery-emissions-analyser",
    path: "battery-emissions-analyser",
    meta: battery_45emissions_45analyserbRvYGu8mnd2FhG4G1HWKnyL5ZkFDEkjV3nNWob5y7k0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/sustainability/battery-emissions-analyser.vue")
  }
]
  },
  {
    name: "battery-gigafactory-sustainability",
    path: "/battery-gigafactory/sustainability",
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/sustainability.vue"),
    children: [
  {
    name: "battery-gigafactory-sustainability-overview",
    path: "overview",
    meta: overviewPorE21G2DcJvXbC2zB9xGLjikG45aEENrm_5mGcJqQQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/sustainability/overview.vue")
  },
  {
    name: "battery-gigafactory-sustainability-battery-emissions-analyser",
    path: "battery-emissions-analyser",
    meta: battery_45emissions_45analyserCbZyhGlfVk43_45UYSJRmFk0IGrb2iEvlhlQLRmNEEuRMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/sustainability/battery-emissions-analyser.vue")
  }
]
  },
  {
    name: "synthetic-graphite-market-insights",
    path: "/synthetic-graphite/market-insights",
    meta: market_45insights6jpXxHyGG6Wo2TGR5uGwUrgWebwVVe9LahhJwKn2NPsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/market-insights.vue"),
    children: [
  {
    name: "synthetic-graphite-market-insights-videos",
    path: "videos",
    meta: videosFgYARxTX82gCmew1FsOwNF_PD5tMFd_45W3SOESwCgKmQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/market-insights/videos.vue")
  },
  {
    name: "synthetic-graphite-market-insights-analysis",
    path: "analysis",
    meta: analysisJyYEHqLSh7FoHIGE00oRhBazBnfdW2tZto1tIkA2OWkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/market-insights/analysis.vue")
  },
  {
    name: "synthetic-graphite-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightstENqEa19jEQuKHTejOqETWAHiowVRpPu71T6Np63y_45MMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "battery-gigafactory-market-insights",
    path: "/battery-gigafactory/market-insights",
    meta: market_45insightsABYc_45XgLcXtzZITJL4UiDb7H_45bwv81_45qChYCBr4ZH3sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/market-insights.vue"),
    children: [
  {
    name: "battery-gigafactory-market-insights-videos",
    path: "videos",
    meta: videosNp3LGbSz_45Fi6zHbglRQS3bNCUb3YVdPFqGCRfR_45fWW8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/market-insights/videos.vue")
  },
  {
    name: "battery-gigafactory-market-insights-analysis",
    path: "analysis",
    meta: analysisvnlDS022c5PHjBlNjjxYMqlAJxXJOXbdrrzTaMduP_45IMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/market-insights/analysis.vue")
  },
  {
    name: "battery-gigafactory-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsW6vfrvQHX60i_45O_45_45HDRLK9BUT998DerUIDSqTAvCwBMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "events-world-tour-2018-london-day-2",
    path: "/events/world-tour-2018/london-day-2",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/london-day-2.vue")
  },
  {
    name: "events-world-tour-2018-san-francisco",
    path: "/events/world-tour-2018/san-francisco",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2018/san-francisco.vue")
  },
  {
    name: "events-world-tour-2019-san-francisco",
    path: "/events/world-tour-2019/san-francisco",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2019/san-francisco.vue")
  },
  {
    name: capacity_45databaseco42LG5QtrGnwlJrYDpDh7uiRmc17mtK4jSLOnCwHKcMeta?.name,
    path: "/battery-gigafactory/capacity-database",
    meta: capacity_45databaseco42LG5QtrGnwlJrYDpDh7uiRmc17mtK4jSLOnCwHKcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/capacity-database.vue"),
    children: [
  {
    name: "battery-gigafactory-capacity-database",
    path: "",
    meta: indexBlR3koxPdeiuXWb4O0X_IasfaD6FoYz2u111LdRFRuwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/index.vue")
  },
  {
    name: "battery-gigafactory-capacity-database-battery-cell",
    path: "battery-cell",
    meta: battery_45cellzh_lsHvarVb1FIm6dRcach7u1RCj9gm7i2E_45CUHdUw0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/battery-cell.vue")
  },
  {
    name: "battery-gigafactory-capacity-database-sodium-ion-capacities",
    path: "sodium-ion-capacities",
    meta: sodium_45ion_45capacitiesrTNtQAlnQH2cwCm2t2EI4gJx5DYeCatPtZORHc2ZXhkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/sodium-ion-capacities.vue")
  }
]
  },
  {
    name: "events-graphite-and-anodes-2018",
    path: "/events/graphite-and-anodes-2018",
    component: () => import("/opt/buildhome/repo/pages/events/graphite-and-anodes-2018/index.vue")
  },
  {
    name: "events-graphite-and-anodes-2019",
    path: "/events/graphite-and-anodes-2019",
    component: () => import("/opt/buildhome/repo/pages/events/graphite-and-anodes-2019/index.vue")
  },
  {
    name: "events-world-tour-2023-new-york",
    path: "/events/world-tour-2023-new-york",
    component: () => import("/opt/buildhome/repo/pages/events/world-tour-2023-new-york/index.vue")
  },
  {
    name: "events-graphite-and-anodes-2018-agenda",
    path: "/events/graphite-and-anodes-2018/agenda",
    component: () => import("/opt/buildhome/repo/pages/events/graphite-and-anodes-2018/agenda.vue")
  },
  {
    name: "events-graphite-and-anodes-2019-agenda",
    path: "/events/graphite-and-anodes-2019/agenda",
    component: () => import("/opt/buildhome/repo/pages/events/graphite-and-anodes-2019/agenda.vue")
  },
  {
    name: "lifetime-achievement-award-jb-straubel",
    path: "/lifetime-achievement-award/jb-straubel",
    component: () => import("/opt/buildhome/repo/pages/lifetime-achievement-award/jb-straubel.vue")
  },
  {
    name: "lithium-ion-battery-raw-material-index",
    path: "/lithium-ion-battery-raw-material-index",
    component: () => import("/opt/buildhome/repo/pages/lithium-ion-battery-raw-material-index.vue")
  },
  {
    name: "lithium-price-assessment-portal-slug",
    path: "/lithium-price-assessment-portal/:slug()",
    component: () => import("/opt/buildhome/repo/pages/lithium-price-assessment-portal/[slug].vue")
  },
  {
    name: "price-assessments-benchmark-statements",
    path: "/price-assessments/benchmark-statements",
    meta: benchmark_45statementsbm7nzuJGLmItZUTXsVSZRh8pEqvXJb_J3Wp2JAihpEEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/price-assessments/benchmark-statements.vue")
  },
  {
    name: "events-benchmark-week-online-2021",
    path: "/events/benchmark-week-online-2021",
    component: () => import("/opt/buildhome/repo/pages/events/benchmark-week-online-2021/index.vue")
  },
  {
    name: "market-market-insights-briefings",
    path: "/:market()/market-insights/briefings",
    meta: indexLKNcEHi9krQyUUFbezdWO1G36WmicLs_450nwH6KyxKdgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[market]/market-insights/briefings/index.vue")
  },
  {
    name: "events-graphite-and-anodes-2018-location",
    path: "/events/graphite-and-anodes-2018/location",
    component: () => import("/opt/buildhome/repo/pages/events/graphite-and-anodes-2018/location.vue")
  },
  {
    name: "events-graphite-and-anodes-2018-sponsors",
    path: "/events/graphite-and-anodes-2018/sponsors",
    component: () => import("/opt/buildhome/repo/pages/events/graphite-and-anodes-2018/sponsors.vue")
  },
  {
    name: "events-graphite-and-anodes-2019-location",
    path: "/events/graphite-and-anodes-2019/location",
    component: () => import("/opt/buildhome/repo/pages/events/graphite-and-anodes-2019/location.vue")
  },
  {
    name: "events-graphite-and-anodes-2019-sponsors",
    path: "/events/graphite-and-anodes-2019/sponsors",
    component: () => import("/opt/buildhome/repo/pages/events/graphite-and-anodes-2019/sponsors.vue")
  },
  {
    name: "price-assessments-all-prices-subscription",
    path: "/price-assessments/all-prices-subscription",
    component: () => import("/opt/buildhome/repo/pages/price-assessments/all-prices-subscription.vue")
  },
  {
    name: "events-benchmark-lithium-summit-2018",
    path: "/events/benchmark-lithium-summit-2018",
    component: () => import("/opt/buildhome/repo/pages/events/benchmark-lithium-summit-2018/index.vue")
  },
  {
    name: "independent-practitioners-assurance-report",
    path: "/independent-practitioners-assurance-report",
    component: () => import("/opt/buildhome/repo/pages/independent-practitioners-assurance-report.vue")
  },
  {
    name: "events-battery-gigafactories-usa-2022",
    path: "/events/battery-gigafactories-usa-2022",
    component: () => import("/opt/buildhome/repo/pages/events/battery-gigafactories-usa-2022/index.vue")
  },
  {
    name: "events-benchmark-minerals-summit-2020",
    path: "/events/benchmark-minerals-summit-2020",
    component: () => import("/opt/buildhome/repo/pages/events/benchmark-minerals-summit-2020/index.vue")
  },
  {
    name: "events-battery-megafactories-europe-2022",
    path: "/events/battery-megafactories-europe-2022",
    component: () => import("/opt/buildhome/repo/pages/events/battery-megafactories-europe-2022/index.vue")
  },
  {
    name: "lifetime-achievement-award-stanley-whittingham",
    path: "/lifetime-achievement-award/stanley-whittingham",
    component: () => import("/opt/buildhome/repo/pages/lifetime-achievement-award/stanley-whittingham.vue")
  },
  {
    name: lithium_45ion_45batteries_45pricesc1qoYTLD6ULkoQ9aBDx2jBIgxAocVkssX6d_FvP4VS0Meta?.name,
    path: "/battery-gigafactory/lithium-ion-batteries-prices",
    meta: lithium_45ion_45batteries_45pricesc1qoYTLD6ULkoQ9aBDx2jBIgxAocVkssX6d_FvP4VS0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices.vue"),
    children: [
  {
    name: "battery-gigafactory-lithium-ion-batteries-prices-chart",
    path: "chart",
    meta: chart9Vq24jqjf6ycod09reGJLcmT8DeOZXfOihrIjrdqDx8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/chart.vue")
  },
  {
    name: "battery-gigafactory-lithium-ion-batteries-prices",
    path: "",
    meta: indexXW_73qxVw_45AO29bMNzSXAJK3RU89H68LA6Ix9p64_q0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/index.vue")
  },
  {
    name: "battery-gigafactory-lithium-ion-batteries-prices-slug",
    path: ":slug()",
    meta: _91slug_93M9Fp0dxzKsebaAaHG0un8dU2nR0q35p8o0UmJs4ToLMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/[slug].vue")
  }
]
  },
  {
    name: "lifetime-achievement-award-arnold-schwarzenegger",
    path: "/lifetime-achievement-award/arnold-schwarzenegger",
    component: () => import("/opt/buildhome/repo/pages/lifetime-achievement-award/arnold-schwarzenegger.vue")
  },
  {
    name: "events-battery-megafactories-europe-2022-location",
    path: "/events/battery-megafactories-europe-2022/location",
    component: () => import("/opt/buildhome/repo/pages/events/battery-megafactories-europe-2022/location.vue")
  },
  {
    name: "market-market-insights-briefings-category-slug",
    path: "/:market()/market-insights/briefings/:category()/:slug()",
    component: () => import("/opt/buildhome/repo/pages/[market]/market-insights/briefings/[category]/[slug].vue")
  },
  {
    name: "market-subCategory-video-by-id",
    path: "/:market/data-reports/:subCategory/video/:id",
    meta: { ...(_91id_93aHRD_45C62bpxQlXiJyTO0jL2I7qPg_pOCc0_xNnliX94Meta || {}), ...{"middleware":["has-active-membership"]} },
    component: () => import("~/custom-pages/[market]/data-reports/[subCategory]/video/[id].vue")
  },
  {
    name: "market-subCategory-report-by-id",
    path: "/:market/data-reports/:subCategory/report/:id",
    meta: { ...(_91id_93fW65Rf0tLwtKeru2QgILXBNROxdqKSkj74UAHmNka1IMeta || {}), ...{"middleware":["has-active-membership"]} },
    component: () => import("~/custom-pages/[market]/data-reports/[subCategory]/report/[id].vue")
  },
  {
    name: "market-report-by-id",
    path: "/:market/data-reports/report/:id",
    meta: { ...(_91id_935fjG9iKCprPRoUGUgPHbl5pkqVS5lZAMFE6hwtlKstQMeta || {}), ...{"middleware":["has-active-membership"]} },
    component: () => import("~/custom-pages/[market]/data-reports/report/[id].vue")
  },
  {
    name: "lithium-futures",
    path: "/lithium/lithium-prices/lithium-futures",
    component: () => import("~/custom-pages/lithium/lithium-prices/lithium-futures.vue")
  },
  {
    name: "cobalt-futures",
    path: "/cobalt/cobalt-prices/cobalt-futures",
    component: () => import("~/custom-pages/cobalt/cobalt-prices/cobalt-futures.vue")
  }
]